import * as Types from './types';

import gql from 'graphql-tag';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CommunityDiscoveryFragmentFragment = { __typename?: 'CommunityNode', id: string, subdomain?: string | null, domain?: string | null, name: string, subtitle?: string | null, description?: string | null, aboutUs?: string | null, logo?: string | null, image: string, locationGlobal: boolean, isPublic: boolean, joinPolicy: Types.CommunityCommunityJoinPolicyChoices, hasJoined: boolean, hasApplied: boolean, isAdmin: boolean, membersCount?: number | null, connectionsCount?: number | null, displayLandingApplication: boolean, tags: Array<{ __typename?: 'CommunityTagNode', name: string, id: string }>, location?: { __typename?: 'CityNode', id: string, name?: string | null, partialName: string, countryCode?: string | null } | null, owner: { __typename?: 'CommunityOwner', id: string, image?: string | null, firstName: string, lastName: string }, landing?: { __typename?: 'LandingWebflowNode', headerSecondaryUrl?: string | null, headerSecondaryUrlTitle?: string | null, applicationFields: Array<{ __typename?: 'ApplicationFieldNode', id: string, required: boolean, placeholder?: string | null, label?: string | null, type: Types.LandingApplicationFieldTypeChoices, name: string, orderId: number }> } | null };

export type CommunitiesQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.CommunitiesFilterEnum>;
  search?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type CommunitiesQuery = { __typename?: 'Query', communities: { __typename?: 'CommunityResultNode', objs: Array<{ __typename?: 'CommunityNode', id: string, subdomain?: string | null, domain?: string | null, name: string, subtitle?: string | null, description?: string | null, aboutUs?: string | null, logo?: string | null, image: string, locationGlobal: boolean, isPublic: boolean, joinPolicy: Types.CommunityCommunityJoinPolicyChoices, hasJoined: boolean, hasApplied: boolean, isAdmin: boolean, membersCount?: number | null, connectionsCount?: number | null, displayLandingApplication: boolean, tags: Array<{ __typename?: 'CommunityTagNode', name: string, id: string }>, location?: { __typename?: 'CityNode', id: string, name?: string | null, partialName: string, countryCode?: string | null } | null, owner: { __typename?: 'CommunityOwner', id: string, image?: string | null, firstName: string, lastName: string }, landing?: { __typename?: 'LandingWebflowNode', headerSecondaryUrl?: string | null, headerSecondaryUrlTitle?: string | null, applicationFields: Array<{ __typename?: 'ApplicationFieldNode', id: string, required: boolean, placeholder?: string | null, label?: string | null, type: Types.LandingApplicationFieldTypeChoices, name: string, orderId: number }> } | null }> } };

export type CommunityQueryVariables = Types.Exact<{
  subdomain?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type CommunityQuery = { __typename?: 'Query', community: { __typename?: 'CommunityNode', id: string, subdomain?: string | null, domain?: string | null, name: string, subtitle?: string | null, description?: string | null, aboutUs?: string | null, logo?: string | null, image: string, locationGlobal: boolean, isPublic: boolean, joinPolicy: Types.CommunityCommunityJoinPolicyChoices, hasJoined: boolean, hasApplied: boolean, isAdmin: boolean, membersCount?: number | null, connectionsCount?: number | null, displayLandingApplication: boolean, tags: Array<{ __typename?: 'CommunityTagNode', name: string, id: string }>, location?: { __typename?: 'CityNode', id: string, name?: string | null, partialName: string, countryCode?: string | null } | null, owner: { __typename?: 'CommunityOwner', id: string, image?: string | null, firstName: string, lastName: string }, landing?: { __typename?: 'LandingWebflowNode', headerSecondaryUrl?: string | null, headerSecondaryUrlTitle?: string | null, applicationFields: Array<{ __typename?: 'ApplicationFieldNode', id: string, required: boolean, placeholder?: string | null, label?: string | null, type: Types.LandingApplicationFieldTypeChoices, name: string, orderId: number }> } | null } };

export type SpaceSettingsMutationVariables = Types.Exact<{
  name: Types.Scalars['String'];
  subtitle?: Types.InputMaybe<Types.Scalars['String']>;
  description: Types.Scalars['String'];
  aboutUs?: Types.InputMaybe<Types.Scalars['String']>;
  locationId?: Types.InputMaybe<Types.Scalars['ID']>;
  locationGlobal?: Types.InputMaybe<Types.Scalars['Boolean']>;
  tags: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
}>;


export type SpaceSettingsMutation = { __typename?: 'Mutation', spaceSettings?: { __typename?: 'SpaceSettingsMutation', community: { __typename?: 'CommunityNode', id: string, subdomain?: string | null, domain?: string | null, name: string, subtitle?: string | null, description?: string | null, aboutUs?: string | null, logo?: string | null, image: string, locationGlobal: boolean, isPublic: boolean, joinPolicy: Types.CommunityCommunityJoinPolicyChoices, hasJoined: boolean, hasApplied: boolean, isAdmin: boolean, membersCount?: number | null, connectionsCount?: number | null, displayLandingApplication: boolean, tags: Array<{ __typename?: 'CommunityTagNode', name: string, id: string }>, location?: { __typename?: 'CityNode', id: string, name?: string | null, partialName: string, countryCode?: string | null } | null, owner: { __typename?: 'CommunityOwner', id: string, image?: string | null, firstName: string, lastName: string }, landing?: { __typename?: 'LandingWebflowNode', headerSecondaryUrl?: string | null, headerSecondaryUrlTitle?: string | null, applicationFields: Array<{ __typename?: 'ApplicationFieldNode', id: string, required: boolean, placeholder?: string | null, label?: string | null, type: Types.LandingApplicationFieldTypeChoices, name: string, orderId: number }> } | null } } | null };

export type CreateCommunityTagMutationVariables = Types.Exact<{
  name: Types.Scalars['String'];
}>;


export type CreateCommunityTagMutation = { __typename?: 'Mutation', createCommunityTag?: { __typename?: 'CreateCommunityTagMutation', tag?: { __typename?: 'CommunityTagNode', id: string, name: string } | null } | null };

export type CommunitySettingsImageMutationVariables = Types.Exact<{
  image: Types.Scalars['String'];
}>;


export type CommunitySettingsImageMutation = { __typename?: 'Mutation', communitySettingsImage?: { __typename?: 'CommunityImageMutation', ok?: boolean | null } | null };

export type DealsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type DealsQuery = { __typename?: 'Query', dealsStats: { __typename?: 'DealsStatsType', uniqueUsers?: number | null, totalFee?: number | null, totalDeals?: number | null }, deals?: Array<{ __typename?: 'HelpNode', createdAt?: any | null, id: string, message?: string | null, emoji?: string | null, title?: string | null, detailsUrl?: string | null, fee?: number | null, user: { __typename?: 'UserNode', id: string, image?: string | null, firstName: string, lastName: string }, viaUsers?: Array<{ __typename?: 'DealUser', id: string, image?: string | null, firstName: string, lastName: string }> | null }> | null };

export type Onb180BasicMutationVariables = Types.Exact<{
  firstName: Types.Scalars['String'];
  lastName: Types.Scalars['String'];
  cityId: Types.Scalars['ID'];
}>;


export type Onb180BasicMutation = { __typename?: 'Mutation', onb180Basic?: { __typename?: 'Onb180BasicMutation', success?: boolean | null } | null };

export type Onb180AboutMutationVariables = Types.Exact<{
  about: Types.Scalars['String'];
}>;


export type Onb180AboutMutation = { __typename?: 'Mutation', onb180About?: { __typename?: 'Onb180AboutMutation', success?: boolean | null } | null };

export type Onb180DreamsMutationVariables = Types.Exact<{
  dreams: Array<Types.DreamInput> | Types.DreamInput;
}>;


export type Onb180DreamsMutation = { __typename?: 'Mutation', onb180Dreams?: { __typename?: 'Onb180DreamsMutation', success?: boolean | null } | null };

export type Onb180UpToMutationVariables = Types.Exact<{
  upTo: Types.Scalars['String'];
}>;


export type Onb180UpToMutation = { __typename?: 'Mutation', onb180UpTo?: { __typename?: 'Onb180UpToMutation', success?: boolean | null } | null };

export type Onb180ProudOfMutationVariables = Types.Exact<{
  proudOf: Array<Types.ProudOfInput> | Types.ProudOfInput;
}>;


export type Onb180ProudOfMutation = { __typename?: 'Mutation', onb180ProudOf?: { __typename?: 'Onb180ProudOfMutation', success?: boolean | null } | null };

export type LoadCommunityTagsMutationVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type LoadCommunityTagsMutation = { __typename?: 'Mutation', loadCommunityTags?: { __typename?: 'LoadCommunityTagsMutation', tags?: Array<{ __typename?: 'CommunityTagNode', id: string, name: string }> | null } | null };

export type SpaceSettingsExtraMutationVariables = Types.Exact<{
  subdomain: Types.Scalars['String'];
  isPublic: Types.Scalars['Boolean'];
  headerSecondaryUrl: Types.Scalars['String'];
  headerSecondaryUrlTitle: Types.Scalars['String'];
}>;


export type SpaceSettingsExtraMutation = { __typename?: 'Mutation', spaceSettingsExtra?: { __typename?: 'SpaceSettingsExtraMutation', community: { __typename?: 'CommunityNode', id: string, subdomain?: string | null, isPublic: boolean, landing?: { __typename?: 'LandingWebflowNode', headerSecondaryUrl?: string | null, headerSecondaryUrlTitle?: string | null } | null } } | null };

export type WinWinChatFragmentFragment = { __typename?: 'WinWinChatType', id: any, createdAt: any, chat: any };

export type WinWinCreateChatMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type WinWinCreateChatMutation = { __typename?: 'Mutation', winwinChatCreate?: { __typename?: 'CreateChatMutation', id: string } | null };

export type WinWinUpdateChatMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  chat: Types.Scalars['JSONString'];
}>;


export type WinWinUpdateChatMutation = { __typename?: 'Mutation', winwinChatUpdate?: { __typename?: 'UpdateChatMutation', ok?: boolean | null } | null };

export type WinWinLoadChatQueryVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['ID']>;
}>;


export type WinWinLoadChatQuery = { __typename?: 'Query', winwinChat?: { __typename?: 'WinWinChatType', id: any, createdAt: any, chat: any } | null };

export type CurrentUserFragmentFragment = { __typename?: 'UserNode', id: string, firstName: string, lastName: string, image?: string | null, dateJoined: any, linkLinkedin?: string | null, toParse: boolean, onboardingFinished: boolean };

export type AcceptApplicationMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type AcceptApplicationMutation = { __typename?: 'Mutation', acceptApplication?: { __typename?: 'AcceptApplicationMutation', ok?: boolean | null, panelUser: { __typename?: 'PanelUserNode', id: string, email?: string | null, firstName: string, lastName: string, image?: string | null } } | null };

export type AddNewDealMutationVariables = Types.Exact<{
  message: Types.Scalars['String'];
  title: Types.Scalars['String'];
  fee: Types.Scalars['Int'];
  detailsUrl?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type AddNewDealMutation = { __typename?: 'Mutation', dealAdd?: { __typename?: 'DealAddMutation', ok?: boolean | null } | null };

export type BlogConnectMediumMutationVariables = Types.Exact<{
  mediumJoinLink: Types.Scalars['String'];
}>;


export type BlogConnectMediumMutation = { __typename?: 'Mutation', blogConnectMedium?: { __typename?: 'CommunityMediumFeedConnectMutation', ok?: boolean | null } | null };

export type CommunitySettingsMutationVariables = Types.Exact<{
  name: Types.Scalars['String'];
  subdomain: Types.Scalars['String'];
}>;


export type CommunitySettingsMutation = { __typename?: 'Mutation', communitySettings?: { __typename?: 'CommunitySettingsMutation', ok?: boolean | null } | null };

export type CommunitySettingsLogoMutationVariables = Types.Exact<{
  logo: Types.Scalars['String'];
}>;


export type CommunitySettingsLogoMutation = { __typename?: 'Mutation', communitySettingsLogo?: { __typename?: 'CommunityLogoMutation', ok?: boolean | null } | null };

export type ConfirmEmailMutationVariables = Types.Exact<{
  token: Types.Scalars['String'];
  uid: Types.Scalars['String'];
}>;


export type ConfirmEmailMutation = { __typename?: 'Mutation', signupConfirm?: { __typename?: 'SignUpConfirmMutation', user: { __typename?: 'UserNode', linkLinkedin?: string | null, id: string, firstName: string, lastName: string, image?: string | null, dateJoined: any, toParse: boolean, onboardingFinished: boolean, communityMember?: { __typename?: 'CommunityMemberNode', role: Types.RoleEnum } | null }, community?: { __typename?: 'CommunityNode', id: string, domain?: string | null, subdomain?: string | null } | null } | null };

export type ConnectConfirmMutationVariables = Types.Exact<{
  connectId: Types.Scalars['ID'];
  confirm: Types.Scalars['Boolean'];
}>;


export type ConnectConfirmMutation = { __typename?: 'Mutation', connectConfirm?: { __typename?: 'ConnectConfirmMutation', ok?: boolean | null } | null };

export type ConnectTelegramMutationVariables = Types.Exact<{
  inviteLink: Types.Scalars['String'];
}>;


export type ConnectTelegramMutation = { __typename?: 'Mutation', connectTelegram?: { __typename?: 'SetCommunityTelegramChatId', ok?: boolean | null } | null };

export type ConnectWhatsappConfirmMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type ConnectWhatsappConfirmMutation = { __typename?: 'Mutation', connectWhatsappConfirm?: { __typename?: 'WhatsappConnectConfirmMutation', connected?: boolean | null } | null };

export type ConnectWhatsappMutationVariables = Types.Exact<{
  inviteLink: Types.Scalars['String'];
}>;


export type ConnectWhatsappMutation = { __typename?: 'Mutation', connectWhatsapp?: { __typename?: 'WhatsappConnectMutation', ok?: boolean | null, manuallyRequired?: boolean | null } | null };

export type CreateApplicationFieldMutationVariables = Types.Exact<{
  type: Types.LandingApplicationFieldTypeChoices;
  orderId: Types.Scalars['Int'];
}>;


export type CreateApplicationFieldMutation = { __typename?: 'Mutation', landingCreateField?: { __typename?: 'CreateApplyFieldMutation', field?: { __typename?: 'ApplicationFieldNode', id: string, required: boolean, placeholder?: string | null, label?: string | null, name: string, type: Types.LandingApplicationFieldTypeChoices, orderId: number } | null } | null };

export type CreateCommunityMutationVariables = Types.Exact<{
  communityName: Types.Scalars['String'];
  communitySubdomain?: Types.InputMaybe<Types.Scalars['String']>;
  app: Types.CommunityAppEnum;
}>;


export type CreateCommunityMutation = { __typename?: 'Mutation', createCommunity?: { __typename?: 'CreateCommunityMutation', community?: { __typename?: 'CommunityNode', id: string, subdomain?: string | null, name: string } | null } | null };

export type CreateNewCompanyMutationVariables = Types.Exact<{
  name: Types.Scalars['String'];
  logo?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type CreateNewCompanyMutation = { __typename?: 'Mutation', createCompany?: { __typename?: 'CreateCompanyMutation', company?: { __typename?: 'CompanyNode', id: string, name: string } | null } | null };

export type CreateNewFeaturedMutationVariables = Types.Exact<{
  title: Types.Scalars['String'];
  url: Types.Scalars['String'];
  image?: Types.InputMaybe<Types.Scalars['String']>;
  description: Types.Scalars['String'];
}>;


export type CreateNewFeaturedMutation = { __typename?: 'Mutation', createFeatured?: { __typename?: 'CreateFeaturedMutation', featured?: { __typename?: 'FeaturedNode', id: string } | null } | null };

export type CreateNewHobbyMutationVariables = Types.Exact<{
  hobby?: Types.InputMaybe<Types.TagInput>;
}>;


export type CreateNewHobbyMutation = { __typename?: 'Mutation', createHobby?: { __typename?: 'CreateHobbyMutation', ok?: boolean | null, hobby?: { __typename?: 'TagNode', id: string, name: string, isHobby: boolean } | null } | null };

export type CreateQualificationMutationVariables = Types.Exact<{
  name: Types.Scalars['String'];
}>;


export type CreateQualificationMutation = { __typename?: 'Mutation', createQualification?: { __typename?: 'CreateQualificationMutation', qualification?: { __typename?: 'QualificationNode', id: string, name: string } | null } | null };

export type CreateNewSkillMutationVariables = Types.Exact<{
  skill?: Types.InputMaybe<Types.TagInput>;
}>;


export type CreateNewSkillMutation = { __typename?: 'Mutation', createSkill?: { __typename?: 'CreateSkillMutation', ok?: boolean | null, skill?: { __typename?: 'TagNode', id: string, name: string, isHobby: boolean } | null } | null };

export type CreateUniversityMutationVariables = Types.Exact<{
  name: Types.Scalars['String'];
}>;


export type CreateUniversityMutation = { __typename?: 'Mutation', createUniversity?: { __typename?: 'CreateUniversityMutation', university?: { __typename?: 'UniversityNode', id: string, name: string } | null } | null };

export type DeleteDealMutationVariables = Types.Exact<{
  dealId: Types.Scalars['ID'];
}>;


export type DeleteDealMutation = { __typename?: 'Mutation', dealDelete?: { __typename?: 'DealDeleteMutation', ok?: boolean | null } | null };

export type DeleteApplicationFieldMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type DeleteApplicationFieldMutation = { __typename?: 'Mutation', landingDeleteField?: { __typename?: 'DeleteApplyFieldMutation', ok: boolean } | null };

export type DeleteUserEducationMutationVariables = Types.Exact<{
  id: Types.Scalars['Int'];
}>;


export type DeleteUserEducationMutation = { __typename?: 'Mutation', deleteEducation?: { __typename?: 'DeleteEducationMutation', success?: boolean | null } | null };

export type DeleteUserExperienceMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type DeleteUserExperienceMutation = { __typename?: 'Mutation', deleteExperience?: { __typename?: 'DeleteExperienceMutation', success?: boolean | null } | null };

export type DeleteUserFeaturedMutationVariables = Types.Exact<{
  id: Types.Scalars['Int'];
}>;


export type DeleteUserFeaturedMutation = { __typename?: 'Mutation', deleteFeatured?: { __typename?: 'DeleteFeaturedMutation', success?: boolean | null } | null };

export type DeleteUserProfileMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type DeleteUserProfileMutation = { __typename?: 'Mutation', deleteProfile?: { __typename?: 'DeleteProfileMutation', ok?: boolean | null } | null };

export type EditDealMutationVariables = Types.Exact<{
  dealId: Types.Scalars['ID'];
  message: Types.Scalars['String'];
  title: Types.Scalars['String'];
  fee: Types.Scalars['Int'];
  detailsUrl?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type EditDealMutation = { __typename?: 'Mutation', dealEdit?: { __typename?: 'DealEditMutation', ok?: boolean | null, deal: { __typename?: 'HelpNode', id: string, message?: string | null, title?: string | null, fee?: number | null, detailsUrl?: string | null } } | null };

export type EditNewFeaturedMutationVariables = Types.Exact<{
  id: Types.Scalars['Int'];
  title: Types.Scalars['String'];
  url: Types.Scalars['String'];
  image?: Types.InputMaybe<Types.Scalars['String']>;
  description: Types.Scalars['String'];
}>;


export type EditNewFeaturedMutation = { __typename?: 'Mutation', editFeatured?: { __typename?: 'EditFeaturedMutation', featured?: { __typename?: 'FeaturedNode', id: string } | null } | null };

export type SendHelpMessageResponseMutationVariables = Types.Exact<{
  message: Types.Scalars['String'];
  helpMessageId: Types.Scalars['ID'];
}>;


export type SendHelpMessageResponseMutation = { __typename?: 'Mutation', helpReact?: { __typename?: 'HelpReactMutation', id?: number | null, ok?: boolean | null } | null };

export type SendIntroMessageMutationVariables = Types.Exact<{
  message: Types.Scalars['String'];
  toUserId: Types.Scalars['ID'];
}>;


export type SendIntroMessageMutation = { __typename?: 'Mutation', connect?: { __typename?: 'ConnectMutation', connectLink?: string | null, ok?: boolean | null } | null };

export type LandingAiMutationVariables = Types.Exact<{
  message: Types.Scalars['String'];
  section: Types.LandingSectionEnum;
  field: Types.LandingSectionFieldEnum;
}>;


export type LandingAiMutation = { __typename?: 'Mutation', landingAi?: { __typename?: 'LandingAIMutation', landing: { __typename?: 'LandingWebflowNode', appType: Types.CommunityLandingWebflowAppTypeChoices, headerImage?: string | null, headerSubtitle: string, headerTitle: string, headerTags?: string | null, applicationFields: Array<{ __typename?: 'ApplicationFieldNode', id: string, label?: string | null, name: string, orderId: number, placeholder?: string | null, required: boolean, type: Types.LandingApplicationFieldTypeChoices }>, benefits: { __typename?: 'LandingBenefitsFields', title?: string | null, description?: string | null, item1?: string | null, item2?: string | null, item3?: string | null, item4?: string | null, item5?: string | null, item6?: string | null }, cta: { __typename?: 'LandingCtaFields', buttonText?: string | null, title?: string | null }, requirements: { __typename?: 'LandingRequirementsFields', title?: string | null, content?: string | null } } } | null };

export type LandingAiMembersCancelMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type LandingAiMembersCancelMutation = { __typename?: 'Mutation', landingAiMembersCancel?: { __typename?: 'LandingAiMembersCancelMutation', ok?: boolean | null } | null };

export type LandingAiMembersRegenerateMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type LandingAiMembersRegenerateMutation = { __typename?: 'Mutation', landingAiMembersRegenerate?: { __typename?: 'LandingAiMembersRegenerateMutation', members: Array<{ __typename?: 'LandingMemberNode', about?: string | null, id: string, image?: string | null, name: string, position?: string | null }> } | null };

export type SaveLandingApplicationFieldsMutationVariables = Types.Exact<{
  fields: Array<Types.ApplicationFieldInput> | Types.ApplicationFieldInput;
}>;


export type SaveLandingApplicationFieldsMutation = { __typename?: 'Mutation', landingApplicationFields?: { __typename?: 'ApplicationFieldsMutation', fields: Array<{ __typename?: 'ApplicationFieldNode', id: string, required: boolean, placeholder?: string | null, label?: string | null, name: string, type: Types.LandingApplicationFieldTypeChoices, orderId: number }> } | null };

export type LandingApplyMutationVariables = Types.Exact<{
  values: Array<Types.LandingApplyInput> | Types.LandingApplyInput;
  communityId?: Types.InputMaybe<Types.Scalars['ID']>;
}>;


export type LandingApplyMutation = { __typename?: 'Mutation', landingApply?: { __typename?: 'LandingApplyMutation', ok?: boolean | null, inviteLink?: string | null } | null };

export type LandingBuilderVideoSeenMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type LandingBuilderVideoSeenMutation = { __typename?: 'Mutation', landingBuilderVideoSeen?: { __typename?: 'LandingBuilderVideoSeenMutation', ok?: boolean | null } | null };

export type LandingJoinSettingsMutationVariables = Types.Exact<{
  joinPolicy: Types.JoinPolicy;
  joinChatLink?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type LandingJoinSettingsMutation = { __typename?: 'Mutation', landingJoinSettings?: { __typename?: 'LandingJoinSettingsMutation', ok?: boolean | null } | null };

export type LandingSecondaryButtonMutationVariables = Types.Exact<{
  title: Types.Scalars['String'];
  url: Types.Scalars['String'];
}>;


export type LandingSecondaryButtonMutation = { __typename?: 'Mutation', landingSecondaryButton?: { __typename?: 'LandingSecondaryButtonMutation', landing?: { __typename?: 'LandingWebflowNode', headerSecondaryUrl?: string | null, headerSecondaryUrlTitle?: string | null } | null } | null };

export type LoadCitiesMutationVariables = Types.Exact<{
  search: Types.Scalars['String'];
}>;


export type LoadCitiesMutation = { __typename?: 'Mutation', loadCities?: { __typename?: 'LoadCitiesMutation', cities: Array<{ __typename?: 'CityNode', id: string, name?: string | null, fullName: string, partialName: string }> } | null };

export type LoadCompaniesMutationVariables = Types.Exact<{
  search: Types.Scalars['String'];
}>;


export type LoadCompaniesMutation = { __typename?: 'Mutation', loadCompanies?: { __typename?: 'LoadCompaniesMutation', companies?: Array<{ __typename?: 'CompanyNode', description?: string | null, id: string, name: string }> | null } | null };

export type LoadHobbiesMutationVariables = Types.Exact<{
  search: Types.Scalars['String'];
}>;


export type LoadHobbiesMutation = { __typename?: 'Mutation', loadHobbies?: { __typename?: 'LoadHobbiesMutation', hobbies: Array<{ __typename?: 'TagNode', id: string, isHobby: boolean, name: string }> } | null };

export type LoadQualificationsMutationVariables = Types.Exact<{
  search: Types.Scalars['String'];
}>;


export type LoadQualificationsMutation = { __typename?: 'Mutation', loadQualifications?: { __typename?: 'LoadQualificationsMutation', qualifications?: Array<{ __typename?: 'QualificationNode', id: string, name: string }> | null } | null };

export type LoadSkillsMutationVariables = Types.Exact<{
  search: Types.Scalars['String'];
}>;


export type LoadSkillsMutation = { __typename?: 'Mutation', loadSkills?: { __typename?: 'LoadSkillsMutation', skills: Array<{ __typename?: 'TagNode', id: string, isHobby: boolean, name: string }> } | null };

export type LoadUniversitiesMutationVariables = Types.Exact<{
  search: Types.Scalars['String'];
}>;


export type LoadUniversitiesMutation = { __typename?: 'Mutation', loadUniversities?: { __typename?: 'LoadUniversitiesMutation', universities?: Array<{ __typename?: 'UniversityNode', id: string, name: string }> | null } | null };

export type LoginUserMutationVariables = Types.Exact<{
  email: Types.Scalars['String'];
  password: Types.Scalars['String'];
}>;


export type LoginUserMutation = { __typename?: 'Mutation', login?: { __typename?: 'LoginMutation', user?: { __typename?: 'UserNode', linkLinkedin?: string | null, id: string, firstName: string, lastName: string, image?: string | null, dateJoined: any, toParse: boolean, onboardingFinished: boolean, communityMember?: { __typename?: 'CommunityMemberNode', role: Types.RoleEnum } | null } | null, community?: { __typename?: 'CommunityNode', id: string, domain?: string | null, subdomain?: string | null } | null } | null };

export type LogoutUserMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type LogoutUserMutation = { __typename?: 'Mutation', logout?: { __typename?: 'LogoutMutation', ok?: boolean | null } | null };

export type MagicSearchFeedbackMutationVariables = Types.Exact<{
  promptId: Types.Scalars['ID'];
  liked: Types.Scalars['Boolean'];
}>;


export type MagicSearchFeedbackMutation = { __typename?: 'Mutation', magicSearchFeedback?: { __typename?: 'MagicSearchFeedback', ok?: boolean | null } | null };

export type MemberConnectTelegramMutationVariables = Types.Exact<{
  hash: Types.Scalars['String'];
  authDate: Types.Scalars['String'];
  id: Types.Scalars['String'];
  firstName: Types.Scalars['String'];
  lastName?: Types.InputMaybe<Types.Scalars['String']>;
  username?: Types.InputMaybe<Types.Scalars['String']>;
  photoUrl?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type MemberConnectTelegramMutation = { __typename?: 'Mutation', memberConnectTelegram?: { __typename?: 'MemberConnectTelegramMutation', communitiesFound?: number | null, ok?: boolean | null } | null };

export type MemberConnectWhatsappMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type MemberConnectWhatsappMutation = { __typename?: 'Mutation', memberConnectWhatsappLink?: { __typename?: 'MemberConnectWhatsappLinkMutation', link?: string | null } | null };

export type MessageMutationVariables = Types.Exact<{
  toUserId: Types.Scalars['ID'];
}>;


export type MessageMutation = { __typename?: 'Mutation', message?: { __typename?: 'MessageMutation', connectLink?: string | null, ok?: boolean | null } | null };

export type RejectApplicationMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type RejectApplicationMutation = { __typename?: 'Mutation', rejectApplication?: { __typename?: 'RejectApplicationMutation', ok?: boolean | null } | null };

export type ResetPasswordMutationVariables = Types.Exact<{
  email: Types.Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: { __typename?: 'ResetPasswordMutation', ok?: boolean | null } | null };

export type ResetPasswordConfirmMutationVariables = Types.Exact<{
  password: Types.Scalars['String'];
  token: Types.Scalars['String'];
  uid: Types.Scalars['String'];
}>;


export type ResetPasswordConfirmMutation = { __typename?: 'Mutation', resetPasswordConfirm?: { __typename?: 'ResetPasswordConfirmMutation', ok?: boolean | null } | null };

export type RevokeMemberMutationVariables = Types.Exact<{
  communityMemberId: Types.Scalars['ID'];
}>;


export type RevokeMemberMutation = { __typename?: 'Mutation', deleteCommunityMember?: { __typename?: 'DeleteCommunityMember', ok?: boolean | null } | null };

export type SaveCanHelpMutationVariables = Types.Exact<{
  message: Types.Scalars['String'];
}>;


export type SaveCanHelpMutation = { __typename?: 'Mutation', helpCan?: { __typename?: 'CanHelpMutation', ok?: boolean | null } | null };

export type SaveHobbiesMutationVariables = Types.Exact<{
  hobbies?: Types.InputMaybe<Array<Types.InputMaybe<Types.SetTagInput>> | Types.InputMaybe<Types.SetTagInput>>;
}>;


export type SaveHobbiesMutation = { __typename?: 'Mutation', saveHobbies?: { __typename?: 'SetHobbiesMutation', ok?: boolean | null } | null };

export type SaveOnBoardingFinishedMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type SaveOnBoardingFinishedMutation = { __typename?: 'Mutation', saveOnboardingFinished?: { __typename?: 'SaveOnboardingFinishedMutation', ok?: boolean | null } | null };

export type SaveSkillsMutationVariables = Types.Exact<{
  skills?: Types.InputMaybe<Array<Types.InputMaybe<Types.SetTagInput>> | Types.InputMaybe<Types.SetTagInput>>;
}>;


export type SaveSkillsMutation = { __typename?: 'Mutation', saveSkills?: { __typename?: 'SetSkillsMutation', ok?: boolean | null } | null };

export type SetCommunityDescriptionMutationVariables = Types.Exact<{
  description: Types.Scalars['String'];
}>;


export type SetCommunityDescriptionMutation = { __typename?: 'Mutation', setCommunityDescription?: { __typename?: 'SetCommunityDescriptionMutation', ok?: boolean | null } | null };

export type SetCommunityGoalsMutationVariables = Types.Exact<{
  goals: Array<Types.Scalars['String']> | Types.Scalars['String'];
}>;


export type SetCommunityGoalsMutation = { __typename?: 'Mutation', setCommunityGoals?: { __typename?: 'SetCommunityGoalsMutation', ok?: boolean | null } | null };

export type SignupMutationVariables = Types.Exact<{
  email: Types.Scalars['String'];
  password: Types.Scalars['String'];
  inviteHash?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type SignupMutation = { __typename?: 'Mutation', signup?: { __typename?: 'SignUpMutation', user?: { __typename?: 'UserNode', id: string } | null } | null };

export type StartMutationVariables = Types.Exact<{
  inviteLink: Types.Scalars['String'];
}>;


export type StartMutation = { __typename?: 'Mutation', start: { __typename?: 'StartMutation', community: { __typename?: 'CommunityNode', id: string, subdomain?: string | null, name: string } } };

export type TelegramAuthUserMutationVariables = Types.Exact<{
  initData: Types.Scalars['String'];
}>;


export type TelegramAuthUserMutation = { __typename?: 'Mutation', telegramAuth?: { __typename?: 'TelegramAuthMutation', user?: { __typename?: 'UserNode', id: string, firstName: string, lastName: string, image?: string | null, dateJoined: any, linkLinkedin?: string | null, toParse: boolean, onboardingFinished: boolean } | null } | null };

export type UpdateEducationMutationVariables = Types.Exact<{
  qualificationId: Types.Scalars['ID'];
  universityId: Types.Scalars['ID'];
  description: Types.Scalars['String'];
  fromMonth?: Types.InputMaybe<Types.Scalars['Int']>;
  fromYear: Types.Scalars['Int'];
  toMonth?: Types.InputMaybe<Types.Scalars['Int']>;
  toYear?: Types.InputMaybe<Types.Scalars['Int']>;
  id?: Types.InputMaybe<Types.Scalars['ID']>;
}>;


export type UpdateEducationMutation = { __typename?: 'Mutation', updateEducation?: { __typename?: 'UpdateEducationMutation', education: { __typename?: 'UpdatedEducationNode', fromMonth?: number | null, fromYear: number, toMonth?: number | null, toYear?: number | null, description?: string | null, id: string, university: { __typename?: 'UniversityNode', id: string, name: string }, qualification: { __typename?: 'QualificationNode', id: string, name: string } } } | null };

export type UpdateExperienceMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID'];
  description: Types.Scalars['String'];
  fromMonth?: Types.InputMaybe<Types.Scalars['Int']>;
  fromYear: Types.Scalars['Int'];
  position: Types.Scalars['String'];
  toMonth?: Types.InputMaybe<Types.Scalars['Int']>;
  toYear?: Types.InputMaybe<Types.Scalars['Int']>;
  id?: Types.InputMaybe<Types.Scalars['ID']>;
}>;


export type UpdateExperienceMutation = { __typename?: 'Mutation', updateExperience?: { __typename?: 'UpdateExperienceMutation', experience: { __typename?: 'UpdatedExperienceNode', positionRaw?: string | null, fromMonth?: number | null, fromYear: number, toMonth?: number | null, toYear?: number | null, description?: string | null, id: string, company?: { __typename?: 'CompanyNode', description?: string | null, id: string, name: string } | null, position?: { __typename?: 'JobTitleNode', id: string, name: string } | null } } | null };

export type UpdateBaseProfileMutationVariables = Types.Exact<{
  firstName?: Types.InputMaybe<Types.Scalars['String']>;
  lastName?: Types.InputMaybe<Types.Scalars['String']>;
  about?: Types.InputMaybe<Types.Scalars['String']>;
  linkYoutube?: Types.InputMaybe<Types.Scalars['String']>;
  linkTelegram?: Types.InputMaybe<Types.Scalars['String']>;
  linkLinkedin?: Types.InputMaybe<Types.Scalars['String']>;
  linkInstagram?: Types.InputMaybe<Types.Scalars['String']>;
  linkFacebook?: Types.InputMaybe<Types.Scalars['String']>;
  linkTwitter?: Types.InputMaybe<Types.Scalars['String']>;
  linkGithub?: Types.InputMaybe<Types.Scalars['String']>;
  linkCalendly?: Types.InputMaybe<Types.Scalars['String']>;
  linkTiktok?: Types.InputMaybe<Types.Scalars['String']>;
  cityId?: Types.InputMaybe<Types.Scalars['ID']>;
  dreams: Array<Types.DreamInput> | Types.DreamInput;
  services: Array<Types.ServiceInput> | Types.ServiceInput;
  proudOf: Array<Types.ProudOfInput> | Types.ProudOfInput;
  upTo?: Types.InputMaybe<Types.Scalars['String']>;
  videoUrl?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type UpdateBaseProfileMutation = { __typename?: 'Mutation', updateBaseProfile?: { __typename?: 'UpdateBaseUserMutation', user?: { __typename?: 'UserNodeUpdated', id: string, firstName: string, lastName: string, about?: string | null, headline?: string | null, linkLinkedin?: string | null, linkInstagram?: string | null, linkTwitter?: string | null, linkGithub?: string | null, linkCalendly?: string | null, linkTiktok?: string | null, upTo?: string | null, videoUrl?: string | null, city: { __typename?: 'CityNode', partialName: string, name?: string | null, id: string }, dreams: Array<{ __typename?: 'DreamNode', title: string, achieved: boolean }>, services: Array<{ __typename?: 'ServiceNode', title: string, price?: number | null }>, proudOf: Array<{ __typename?: 'ProudOfNode', title: string, imageUrl?: string | null, description?: string | null, url?: string | null }> } | null } | null };

export type WorkedWithMutationVariables = Types.Exact<{
  userId: Types.Scalars['ID'];
}>;


export type WorkedWithMutation = { __typename?: 'Mutation', workedWith?: { __typename?: 'WorkedWithMutation', ok?: boolean | null } | null };

export type WorkedWithConfirmMutationVariables = Types.Exact<{
  workedWithId: Types.Scalars['ID'];
  confirm: Types.Scalars['Boolean'];
}>;


export type WorkedWithConfirmMutation = { __typename?: 'Mutation', workedWithConfirm?: { __typename?: 'WorkedWithConfirmMutation', ok?: boolean | null } | null };

export type LandingPublishMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type LandingPublishMutation = { __typename?: 'Mutation', landingPublish?: { __typename?: 'LandingPublishMutation', ok?: boolean | null } | null };

export type LandingSetBenefitsFieldsMutationVariables = Types.Exact<{
  benefitsInput: Types.LandingBenefitsInput;
}>;


export type LandingSetBenefitsFieldsMutation = { __typename?: 'Mutation', landingSetFields?: { __typename?: 'LandingFieldsMutation', landing?: { __typename?: 'LandingWebflowNode', benefits: { __typename?: 'LandingBenefitsFields', title?: string | null, description?: string | null, item1?: string | null, item2?: string | null, item3?: string | null, item4?: string | null, item5?: string | null, item6?: string | null } } | null } | null };

export type LandingSetCtaFieldsMutationVariables = Types.Exact<{
  title: Types.Scalars['String'];
  buttonText: Types.Scalars['String'];
}>;


export type LandingSetCtaFieldsMutation = { __typename?: 'Mutation', landingSetFields?: { __typename?: 'LandingFieldsMutation', landing?: { __typename?: 'LandingWebflowNode', cta: { __typename?: 'LandingCtaFields', title?: string | null, buttonText?: string | null } } | null } | null };

export type LandingSetHeaderFieldsMutationVariables = Types.Exact<{
  headerFields: Types.LandingHeaderInput;
}>;


export type LandingSetHeaderFieldsMutation = { __typename?: 'Mutation', landingSetFields?: { __typename?: 'LandingFieldsMutation', landing?: { __typename?: 'LandingWebflowNode', headerSubtitle: string, headerTags?: string | null, headerTitle: string, membersNumber?: string | null, youtubeVideoUrl?: string | null } | null } | null };

export type LandingSetHeaderImageMutationVariables = Types.Exact<{
  image: Types.Scalars['String'];
}>;


export type LandingSetHeaderImageMutation = { __typename?: 'Mutation', landingSetHeaderImage?: { __typename?: 'LandingHeaderImageMutation', landing?: { __typename?: 'LandingWebflowNode', headerImage?: string | null } | null } | null };

export type LandingSetMemberFieldsMutationVariables = Types.Exact<{
  member: Types.LandingMemberInput;
}>;


export type LandingSetMemberFieldsMutation = { __typename?: 'Mutation', landingMember?: { __typename?: 'LandingMemberMutation', member?: { __typename?: 'LandingMemberNode', id: string, name: string, position?: string | null, about?: string | null, image?: string | null } | null } | null };

export type LandingSetMemberImageMutationVariables = Types.Exact<{
  image: Types.Scalars['String'];
  memberId: Types.Scalars['ID'];
}>;


export type LandingSetMemberImageMutation = { __typename?: 'Mutation', landingMemberImage?: { __typename?: 'LandingMemberImageMutation', member?: { __typename?: 'LandingMemberNode', image?: string | null } | null } | null };

export type LandingSetRequirementsFieldsMutationVariables = Types.Exact<{
  title: Types.Scalars['String'];
  content: Types.Scalars['String'];
}>;


export type LandingSetRequirementsFieldsMutation = { __typename?: 'Mutation', landingSetFields?: { __typename?: 'LandingFieldsMutation', landing?: { __typename?: 'LandingWebflowNode', requirements: { __typename?: 'LandingRequirementsFields', title?: string | null, content?: string | null } } | null } | null };

export type SaveImageProfileMutationVariables = Types.Exact<{
  image: Types.Scalars['String'];
}>;


export type SaveImageProfileMutation = { __typename?: 'Mutation', saveImageProfile?: { __typename?: 'SaveImageUserMutation', image: string } | null };

export type SaveLinkedInMutationVariables = Types.Exact<{
  linkLinkedin: Types.Scalars['String'];
}>;


export type SaveLinkedInMutation = { __typename?: 'Mutation', saveLinkedin?: { __typename?: 'SaveLinkedinMutation', ok?: boolean | null } | null };

export type SaveSocialMutationVariables = Types.Exact<{
  linkFacebook?: Types.InputMaybe<Types.Scalars['String']>;
  linkInstagram?: Types.InputMaybe<Types.Scalars['String']>;
  linkLinkedin?: Types.InputMaybe<Types.Scalars['String']>;
  linkTelegram?: Types.InputMaybe<Types.Scalars['String']>;
  linkYoutube?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type SaveSocialMutation = { __typename?: 'Mutation', saveSocial?: { __typename?: 'UserSocialMutation', user?: { __typename?: 'UserNode', id: string, firstName: string, lastName: string, about?: string | null } | null } | null };

export type SetPricingMutationVariables = Types.Exact<{
  monthly: Types.Scalars['Decimal'];
}>;


export type SetPricingMutation = { __typename?: 'Mutation', setPricing?: { __typename?: 'SetPricing', pricing?: { __typename?: 'PricingNode', monthly: any } | null } | null };

export type SetSubscriptionTypeMutationVariables = Types.Exact<{
  type: Types.SubscriptionTypeEnum;
}>;


export type SetSubscriptionTypeMutation = { __typename?: 'Mutation', setSubscriptionType?: { __typename?: 'SetSubscriptionType', next?: string | null, ok?: boolean | null } | null };

export type ActivityQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ActivityQuery = { __typename?: 'Query', activity?: Array<{ __typename: 'ConnectNode', message?: string | null, connectId: string, connectCreatedAt: any, connectConfirmed: Types.ConfirmedEnum, connectFromUser?: { __typename?: 'UserNode', id: string, image?: string | null, firstName: string, lastName: string } | null } | { __typename?: 'HelpNode', helpCreatedAt?: any | null, helpNodeId: string, helpMessage?: string | null, helpFromUser: { __typename?: 'UserNode', id: string, image?: string | null, firstName: string, lastName: string } } | { __typename: 'HelpReactionNode', createdAt: any, user?: { __typename?: 'UserNode', id: string, image?: string | null, firstName: string, lastName: string } | null } | { __typename: 'JoinedMemberNode', joinedAt: any, joinedMemberUser: { __typename?: 'UserNode', id: string, firstName: string, lastName: string, image?: string | null } } | { __typename: 'WorkedWithRequestNode', workedWithId: string, workedWithCreatedAt: any, workedWithConfirmed: Types.ConfirmedEnum, fromUser: { __typename?: 'PanelUserNode', id: string, image?: string | null, firstName: string, lastName: string } }> | null };

export type ActivityCountQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ActivityCountQuery = { __typename?: 'Query', activityCount: number };

export type AllCitiesQueryVariables = Types.Exact<{
  search: Types.Scalars['String'];
}>;


export type AllCitiesQuery = { __typename?: 'Query', allCities: Array<{ __typename?: 'CityNode', id: string, name?: string | null }> };

export type AnalyticsActivationQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AnalyticsActivationQuery = { __typename?: 'Query', analyticsActivationPeriod?: { __typename?: 'ActivationPeriodNode', periodLast: number, periodAll: number } | null };

export type AnalyticsApplicationsQueryVariables = Types.Exact<{
  filters: Types.FiltersV2;
}>;


export type AnalyticsApplicationsQuery = { __typename?: 'Query', analyticsApplications?: Array<{ __typename?: 'ApplicationsNode', timestamp: any, new: number, accepted: number, rejected: number }> | null };

export type AnalyticsHeatmapMessagesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AnalyticsHeatmapMessagesQuery = { __typename?: 'Query', analyticsHeatmap?: Array<{ __typename?: 'HeatmapNode', timestamp: any, messages: number }> | null };

export type AnalyticsMembersCountriesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AnalyticsMembersCountriesQuery = { __typename?: 'Query', analyticsMembersCountries?: Array<{ __typename?: 'MemberCountryNode', countryCode: string, members: number }> | null };

export type AnalyticsMembersLeftListQueryVariables = Types.Exact<{
  filters: Types.FiltersV2;
}>;


export type AnalyticsMembersLeftListQuery = { __typename?: 'Query', analyticsMembersLeft?: Array<{ __typename?: 'LeftMemberNode', leftAt: any, name?: string | null, rawId: string, image?: string | null, user?: { __typename?: 'UserNode', id: string, lastName: string, firstName: string, image?: string | null, city?: { __typename?: 'CityNode', name?: string | null } | null } | null }> | null };

export type AnalyticsMembersLeftV2QueryVariables = Types.Exact<{
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  filters?: Types.InputMaybe<Types.FiltersV2>;
}>;


export type AnalyticsMembersLeftV2Query = { __typename?: 'Query', analyticsMembersLeftV2?: { __typename?: 'LeftMemberConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'LeftMemberEdge', node?: { __typename?: 'LeftMemberNode', rawId: string, leftAt: any, image?: string | null, name?: string | null, user?: { __typename?: 'UserNode', id: string, image?: string | null, firstName: string, lastName: string, city?: { __typename?: 'CityNode', name?: string | null } | null } | null } | null } | null> } | null };

export type AnalyticsMembersLifetimeListQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AnalyticsMembersLifetimeListQuery = { __typename?: 'Query', analyticsMembersLifetime?: Array<{ __typename?: 'MemberLifetimeNode', group: Types.LifetimeEnum, members: number }> | null };

export type AnalyticsMembersTopListQueryVariables = Types.Exact<{
  filters: Types.FiltersV2;
}>;


export type AnalyticsMembersTopListQuery = { __typename?: 'Query', analyticsMembersTop?: Array<{ __typename?: 'TopMemberNode', messages: number, name?: string | null, rawId: string, image?: string | null, link?: { __typename?: 'MemberLinkNode', url: string, service: Types.AppType } | null, user?: { __typename?: 'UserNode', id: string, lastName: string, firstName: string, image?: string | null, city?: { __typename?: 'CityNode', name?: string | null } | null } | null }> | null };

export type AnalyticsMessageTypesListQueryVariables = Types.Exact<{
  filters: Types.FiltersV2;
}>;


export type AnalyticsMessageTypesListQuery = { __typename?: 'Query', analyticsMessageTypes?: Array<{ __typename?: 'MessageTypeNode', messageType: string, messages: number }> | null };

export type AnalyticsStagesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AnalyticsStagesQuery = { __typename?: 'Query', analyticsStages?: Array<{ __typename?: 'StagesNode', members: number, stage: Types.StagesEnum }> | null };

export type AnalyticsApplicationsSummaryQueryVariables = Types.Exact<{
  filters: Types.FiltersV2;
}>;


export type AnalyticsApplicationsSummaryQuery = { __typename?: 'Query', analyticsSummaryApplications: { __typename?: 'SummaryApplicationsNode', applications: number, applicationsChange: number } };

export type AnalyticsLikesSummaryQueryVariables = Types.Exact<{
  filters: Types.FiltersV2;
}>;


export type AnalyticsLikesSummaryQuery = { __typename?: 'Query', analyticsSummaryLikes: { __typename?: 'SummaryLikesNode', likes: number, likesChange: number } };

export type AnalyticsMembersSummaryQueryVariables = Types.Exact<{
  filters: Types.FiltersV2;
}>;


export type AnalyticsMembersSummaryQuery = { __typename?: 'Query', analyticsSummaryMembers: { __typename?: 'SummaryMembersNode', members: number, membersChange: number } };

export type AnalyticsMessagesSummaryQueryVariables = Types.Exact<{
  filters: Types.FiltersV2;
}>;


export type AnalyticsMessagesSummaryQuery = { __typename?: 'Query', analyticsSummaryMessages: { __typename?: 'SummaryMessagesNode', messages: number, messagesChange: number } };

export type AnalyticsV2MembersQueryVariables = Types.Exact<{
  filters: Types.FiltersV2;
}>;


export type AnalyticsV2MembersQuery = { __typename?: 'Query', analyticsMembers?: Array<{ __typename?: 'MembersV2Node', timestamp: any, joined: number, left: number }> | null };

export type AnalyticsV2MessagesQueryVariables = Types.Exact<{
  filters: Types.FiltersV2;
}>;


export type AnalyticsV2MessagesQuery = { __typename?: 'Query', analyticsMessages?: Array<{ __typename?: 'MessagesNode', timestamp: any, users: number, messages: number, avgMessages: number }> | null };

export type AnalyticsV2ReactionsQueryVariables = Types.Exact<{
  filters: Types.FiltersV2;
}>;


export type AnalyticsV2ReactionsQuery = { __typename?: 'Query', analyticsReactions?: Array<{ __typename?: 'ReactionsNode', timestamp: any, reactions: number }> | null };

export type AnalyticsV2StatsQueryVariables = Types.Exact<{
  filters: Types.FiltersV2;
}>;


export type AnalyticsV2StatsQuery = { __typename?: 'Query', analyticsStats?: Array<{ __typename?: 'StatsNode', timestamp: any, chatMembers: number, profiles: number, landingViews: number, landingClicks: number, stagesNotActivated: number, stagesActivated: number, stagesEngaged: number, stagesLost: number, stagesActivatedPeriod: number, stagesEngagedPeriod: number, stagesLostPeriod: number, referrers: Array<{ __typename?: 'ReferrerNode', referrer: string, count: number }> }> | null };

export type LandingApplicationFieldsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LandingApplicationFieldsQuery = { __typename?: 'Query', landing: { __typename?: 'LandingWebflowNode', applicationFields: Array<{ __typename?: 'ApplicationFieldNode', id: string, required: boolean, placeholder?: string | null, label?: string | null, type: Types.LandingApplicationFieldTypeChoices, name: string, orderId: number }> } };

export type BlogRecentQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type BlogRecentQuery = { __typename?: 'Query', blogUrl?: string | null, blogRecent?: Array<{ __typename?: 'BlogNode', content?: string | null, createdAt: any, fullUrl: string, image?: string | null, title: string }> | null };

export type CitiesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CitiesQuery = { __typename?: 'Query', cities: Array<{ __typename?: 'CityNode', id: string, name?: string | null }> };

export type ApplicationQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type ApplicationQuery = { __typename?: 'Query', application: { __typename?: 'ApplicationNode', id: string, createdAt: any, name?: string | null, phone?: string | null, email?: string | null, status: Types.CommunityApplicationStatusChoices, answers: Array<{ __typename?: 'ApplicationAnswer', label?: string | null, value?: string | null }> } };

export type ApplicationsQueryVariables = Types.Exact<{
  status: Array<Types.CommunityApplicationStatusChoices> | Types.CommunityApplicationStatusChoices;
}>;


export type ApplicationsQuery = { __typename?: 'Query', applications?: { __typename?: 'ApplicationsResponse', applications: Array<{ __typename?: 'ApplicationNode', id: string, createdAt: any, name?: string | null, phone?: string | null, email?: string | null, status: Types.CommunityApplicationStatusChoices, answers: Array<{ __typename?: 'ApplicationAnswer', label?: string | null, value?: string | null }> }> } | null };

export type ApplicationsCountQueryVariables = Types.Exact<{
  status: Array<Types.CommunityApplicationStatusChoices> | Types.CommunityApplicationStatusChoices;
}>;


export type ApplicationsCountQuery = { __typename?: 'Query', applications?: { __typename?: 'ApplicationsResponse', count?: number | null } | null };

export type CommunityInfoQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CommunityInfoQuery = { __typename?: 'Query', communityInfo?: { __typename?: 'CommunityNode', id: string, name: string, subtitle?: string | null, description?: string | null, logo?: string | null, videoEmbeddedLink?: string | null, subdomain?: string | null, domain?: string | null, membersCount?: number | null, isTelegramConnected?: boolean | null, isWhatsappConnected?: boolean | null, historyDownloadStarted?: any | null, historyDownloadFinished?: any | null, historyDownloadError?: string | null, app?: Types.CommunityCommunityAppChoices | null, joinPolicy: Types.CommunityCommunityJoinPolicyChoices, membersConfirmation: boolean, displayLandingApplication: boolean, telegramJoinChatLink?: string | null, isWhatsappGroupJoined?: boolean | null, isWhatsappGroupSet?: boolean | null, mediumJoinLink?: string | null, subscriptionConnectionLink?: string | null, subscriptionType: Types.CommunityCommunitySubscriptionTypeChoices, stripePayoutsEnabled?: boolean | null, stripeChargesEnabled?: boolean | null, stripeDetailsSubmitted?: boolean | null, pricing?: { __typename?: 'PricingNode', monthly: any } | null } | null };

export type CompanyNodesQueryVariables = Types.Exact<{
  name?: Types.InputMaybe<Types.Scalars['String']>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type CompanyNodesQuery = { __typename?: 'Query', companies: Array<{ __typename?: 'CompanyNode', id: string, name: string }> };

export type CurrentUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'UserNode', profileStatus?: Types.UsersYkmeUserProfileStatusChoices | null, inviteHash?: string | null, isTelegramConnected: boolean, isWhatsappConnected: boolean, isLinkedinError: boolean, id: string, firstName: string, lastName: string, image?: string | null, dateJoined: any, linkLinkedin?: string | null, toParse: boolean, onboardingFinished: boolean, tags: Array<{ __typename?: 'TagNode', id: string, isHobby: boolean, name: string, usersCount?: number | null }>, communityMember?: { __typename?: 'CommunityMemberNode', role: Types.RoleEnum, subscription: { __typename?: 'MemberSubscriptionNode', status: Types.MemberSubscriptionStatusEnum } } | null, communityMembers?: Array<{ __typename?: 'CommunityMemberNode', role: Types.RoleEnum, subscription: { __typename?: 'MemberSubscriptionNode', status: Types.MemberSubscriptionStatusEnum }, community: { __typename?: 'CommunityNode', id: string, subdomain?: string | null, name: string, logo?: string | null, membersCount?: number | null } }> | null, workedWith?: Array<{ __typename?: 'WorkedWithNode', id: string, image?: string | null, name: string }> | null } | null };

export type EducationQueryVariables = Types.Exact<{
  ID: Types.Scalars['Int'];
}>;


export type EducationQuery = { __typename?: 'Query', education?: { __typename?: 'EducationNode', id: string, description?: string | null, university: { __typename?: 'UniversityNode', id: string, name: string }, qualification?: { __typename?: 'QualificationNode', id: string, name: string } | null } | null };

export type ExperienceQueryVariables = Types.Exact<{
  ID: Types.Scalars['ID'];
}>;


export type ExperienceQuery = { __typename?: 'Query', experience?: { __typename?: 'CompanyExperienceNode', id: string, description?: string | null, company?: { __typename?: 'CompanyNode', id: string, name: string } | null, position?: { __typename?: 'JobTitleNode', id: string, name: string } | null } | null };

export type FeaturedQueryVariables = Types.Exact<{
  ID: Types.Scalars['Int'];
}>;


export type FeaturedQuery = { __typename?: 'Query', featured?: { __typename?: 'FeaturedNode', id: string, title?: string | null, description?: string | null, image?: string | null, url?: string | null } | null };

export type FiltersValuesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FiltersValuesQuery = { __typename?: 'Query', cities: Array<{ __typename?: 'CityNode', id: string, name?: string | null }>, directions?: Array<{ __typename?: 'DirectionGroupNode', id: string, name: string, usersCount?: number | null }> | null, jobTitles?: Array<{ __typename?: 'JobTitleGroupNode', id: string, name: string, usersCount?: number | null }> | null, tags: Array<{ __typename?: 'TagNode', id: string, isHobby: boolean, name: string, usersCount?: number | null }> };

export type HobbiesQueryVariables = Types.Exact<{
  systemOnly?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type HobbiesQuery = { __typename?: 'Query', hobbies: Array<{ __typename?: 'TagNode', isHobby: boolean, id: string, name: string }> };

export type InviteUserQueryVariables = Types.Exact<{
  inviteHash?: Types.InputMaybe<Types.Scalars['String']>;
  redirect?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type InviteUserQuery = { __typename?: 'Query', invitedByUser?: { __typename?: 'UserNode', id: string, firstName: string, lastName: string, image?: string | null, dateJoined: any, linkLinkedin?: string | null, toParse: boolean, onboardingFinished: boolean } | null, oauthLinks: Array<{ __typename?: 'OAuthLink', provider: Types.OAuthProvider, link: string }> };

export type IsLoggedInQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type IsLoggedInQuery = { __typename?: 'Query', isLoggedIn?: boolean | null };

export type JobTitleNodesQueryVariables = Types.Exact<{
  name?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type JobTitleNodesQuery = { __typename?: 'Query', positions: Array<{ __typename?: 'JobTitleNode', id: string, name: string }> };

export type JobTypesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type JobTypesQuery = { __typename?: 'Query', jobTypeChoices?: Array<{ __typename?: 'JobTypeChoiceType', value?: number | null, label?: string | null } | null> | null };

export type LandingQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LandingQuery = { __typename?: 'Query', landing: { __typename?: 'LandingWebflowNode', id: string, headerImage?: string | null, headerSubtitle: string, headerTags?: string | null, headerTitle: string, headerButtonCustom?: string | null, icons?: Array<string> | null, youtubeVideoUrl?: string | null, membersNumber?: string | null, builderVideoSeen: boolean, headerSecondaryUrl?: string | null, headerSecondaryUrlTitle?: string | null, membersStatus?: Types.MembersStatusEnum | null, members: Array<{ __typename?: 'LandingMemberNode', about?: string | null, id: string, image?: string | null, name: string, position?: string | null }>, benefits: { __typename?: 'LandingBenefitsFields', title?: string | null, description?: string | null, item1?: string | null, item2?: string | null, item3?: string | null, item4?: string | null, item5?: string | null, item6?: string | null }, cta: { __typename?: 'LandingCtaFields', buttonText?: string | null, title?: string | null }, requirements: { __typename?: 'LandingRequirementsFields', title?: string | null, content?: string | null } } };

export type LandingMembersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LandingMembersQuery = { __typename?: 'Query', landing: { __typename?: 'LandingWebflowNode', membersNumber?: string | null, membersStatus?: Types.MembersStatusEnum | null, members: Array<{ __typename?: 'LandingMemberNode', about?: string | null, id: string, image?: string | null, name: string, position?: string | null }> } };

export type LoginWhatsappMutationVariables = Types.Exact<{
  codeId: Types.Scalars['String'];
}>;


export type LoginWhatsappMutation = { __typename?: 'Mutation', memberConnectWhatsappConfirm?: { __typename?: 'MemberConnectWhatsappConfirmMutation', user?: { __typename?: 'UserNode', id: string, firstName: string, lastName: string, image?: string | null, dateJoined: any, linkLinkedin?: string | null, toParse: boolean, onboardingFinished: boolean } | null } | null };

export type MembersQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.UserFilters>;
  promptId?: Types.InputMaybe<Types.Scalars['ID']>;
  lastId?: Types.InputMaybe<Types.Scalars['ID']>;
}>;


export type MembersQuery = { __typename?: 'Query', users?: { __typename?: 'UsersResultNode', promptId?: string | null, hasMore: boolean, objs: Array<{ __typename?: 'UserNode', id: string, firstName: string, lastName: string, image?: string | null, headline?: string | null, communityMembers?: Array<{ __typename?: 'CommunityMemberNode', community: { __typename?: 'CommunityNode', id: string, name: string, subdomain?: string | null, domain?: string | null, logo?: string | null } }> | null, needHelp?: { __typename?: 'CurrentHelpNode', id: string, message: string } | null, city?: { __typename?: 'CityNode', name?: string | null } | null, workedWith?: Array<{ __typename?: 'WorkedWithNode', id: string, image?: string | null, name: string }> | null, connection?: { __typename?: 'Connection', match?: Array<string> | null, connected: boolean, connect?: { __typename?: 'ConnectionConnectNode', confirmed: Types.ConfirmedEnum, fromThey: boolean, message?: string | null, connectId: string } | null, helpReaction?: { __typename?: 'ConnectionHelpReactionNode', helpId: string, help: string } | null, workedWith?: { __typename?: 'ConnectionWorkedWithNode', confirmed: Types.ConfirmedEnum, fromThey: boolean, workedWithId: string } | null } | null }> } | null };

export type PanelV2QueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PanelV2Query = { __typename?: 'Query', panel?: Array<{ __typename: 'ApplicationNode', id: string, createdAt: any, name?: string | null, phone?: string | null, email?: string | null, status: Types.CommunityApplicationStatusChoices, member?: { __typename?: 'CommunityMemberNode', userId?: string | null } | null } | { __typename: 'PanelMemberNode', id: string, createdAt: any, applicationId?: string | null, role: Types.CommunityCommunityMemberRoleChoices, revokedAt?: any | null, user: { __typename?: 'PanelUserNode', id: string, email?: string | null, firstName: string, lastName: string, image?: string | null } } | { __typename: 'PanelRevokedNode', id: string, createdAt: any, applicationId?: string | null, role: Types.CommunityCommunityMemberRoleChoices, revokedAt?: any | null, user: { __typename?: 'PanelUserNode', id: string, email?: string | null, firstName: string, lastName: string, image?: string | null } } | { __typename: 'RejectedApplicationNode', id: string, createdAt: any, name?: string | null, phone?: string | null, email?: string | null, status: Types.CommunityApplicationStatusChoices, statusChangedAt?: any | null, member?: { __typename?: 'CommunityMemberNode', userId?: string | null } | null }> | null };

export type QualificationNodesQueryVariables = Types.Exact<{
  name?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type QualificationNodesQuery = { __typename?: 'Query', qualifications: Array<{ __typename?: 'QualificationNode', id: string, name: string }> };

export type RequestsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type RequestsQuery = { __typename?: 'Query', requests: Array<{ __typename?: 'RequestNode', request: string }> };

export type SkillsQueryVariables = Types.Exact<{
  systemOnly?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type SkillsQuery = { __typename?: 'Query', skills: Array<{ __typename?: 'TagNode', isHobby: boolean, id: string, name: string }> };

export type StatMembersListQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type StatMembersListQuery = { __typename?: 'Query', statMembers?: Array<{ __typename?: 'StatMemberNode', id: string, idRaw: string, username?: string | null, bio?: string | null, name?: string | null, languageCode?: string | null, phone?: string | null, picture?: string | null, joinedAt?: any | null, leftAt?: any | null, messagesSent?: number | null, reactionsSent?: number | null, stage?: string | null, aiCity?: string | null, aiSummary?: string | null, aiAchievements?: string | null, aiTags?: string | null, aiCurrentJob?: string | null, aiCurrentCompany?: string | null, aiLookingFor?: string | null, aiLinkedin?: string | null, aiProjectUrl?: string | null, aiSearchPrompts?: string | null, aiLookupLinkedinUrl?: string | null, aiLookupLinkedinFirstName?: string | null, aiLookupLinkedinLastName?: string | null, aiLookupLinkedinBioSummary?: string | null, aiLookupLinkedinNotFound?: boolean | null, aiLookupLinkedinProbability?: number | null, aiLookupLinkedinUpdatedAt?: any | null }> | null };

export type StatMessagesListQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type StatMessagesListQuery = { __typename?: 'Query', statMessages?: Array<{ __typename?: 'FeedMessageNode', rawMessage?: string | null, reactionsCount?: number | null, timestamp: any, reactions?: Array<{ __typename?: 'FeedReactionsNode', count?: number | null, reaction?: string | null }> | null }> | null };

export type StripeCustomerPortalUrlQueryVariables = Types.Exact<{
  returnUrl: Types.Scalars['String'];
}>;


export type StripeCustomerPortalUrlQuery = { __typename?: 'Query', stripeCustomerPortalUrl?: string | null };

export type StripeEmbeddedCodeQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type StripeEmbeddedCodeQuery = { __typename?: 'Query', stripeEmbedded?: string | null };

export type SubscriptionQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SubscriptionQuery = { __typename?: 'Query', currentUser?: { __typename?: 'UserNode', communityMember?: { __typename?: 'CommunityMemberNode', role: Types.RoleEnum, subscription: { __typename?: 'MemberSubscriptionNode', status: Types.MemberSubscriptionStatusEnum, stripeSubscription?: { __typename?: 'StripeSubscription', createdAt: any, description?: string | null, price: number, status: string, currentPeriodEnd?: any | null, currentPeriodStart?: any | null, invoices?: Array<{ __typename?: 'StripeInvoice', total: number, status: string, currency: string, datetime: any }> | null } | null } } | null } | null };

export type TelegramConfigurationQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TelegramConfigurationQuery = { __typename?: 'Query', telegramConfiguration?: { __typename?: 'TelegramConfiguration', botHandle?: string | null, authUrl?: string | null } | null };

export type UniversityNodesQueryVariables = Types.Exact<{
  name?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type UniversityNodesQuery = { __typename?: 'Query', universities: Array<{ __typename?: 'UniversityNode', id: string, name: string }> };

export type UserQueryVariables = Types.Exact<{
  ID?: Types.InputMaybe<Types.Scalars['ID']>;
}>;


export type UserQuery = { __typename?: 'Query', user?: { __typename?: 'UserNode', id: string, firstName: string, lastName: string, image?: string | null, headline?: string | null, about?: string | null, seoNoindex: boolean, videoUrl?: string | null, videoEmbedUrl?: string | null, upTo?: string | null, linkFacebook?: string | null, linkInstagram?: string | null, linkTelegram?: string | null, linkLinkedin?: string | null, linkYoutube?: string | null, linkGithub?: string | null, linkTwitter?: string | null, linkCalendly?: string | null, linkTiktok?: string | null, toParse: boolean, onboardingFinished: boolean, profileStatus?: Types.UsersYkmeUserProfileStatusChoices | null, needHelp?: { __typename?: 'CurrentHelpNode', id: string, message: string, currentUserReacted?: boolean | null, reactedBy: Array<string>, reactedByV2: Array<{ __typename?: 'ReactedByNode', image?: string | null, userId: string, name: string }> } | null, city?: { __typename?: 'CityNode', id: string, name?: string | null, partialName: string } | null, tags: Array<{ __typename?: 'TagNode', id: string, name: string, isHobby: boolean }>, dreams: Array<{ __typename?: 'DreamNode', title: string, achieved: boolean }>, services: Array<{ __typename?: 'ServiceNode', title: string, price?: number | null }>, proudOf: Array<{ __typename?: 'ProudOfNode', title: string, imageUrl?: string | null, description?: string | null, url?: string | null }>, education?: Array<{ __typename?: 'EducationNode', id: string, speciality?: string | null, years?: string | null, fromMonth?: number | null, fromYear?: number | null, toMonth?: number | null, toYear?: number | null, university: { __typename?: 'UniversityNode', id: string, name: string, logo?: string | null }, qualification?: { __typename?: 'QualificationNode', id: string, name: string } | null }> | null, companyExperience?: Array<{ __typename?: 'CompanyExperienceNode', id: string, description?: string | null, positionRaw?: string | null, fromMonth?: number | null, fromYear?: number | null, toMonth?: number | null, toYear?: number | null, company?: { __typename?: 'CompanyNode', id: string, name: string, logo?: string | null } | null, position?: { __typename?: 'JobTitleNode', id: string, name: string } | null }> | null, featured?: Array<{ __typename?: 'FeaturedNode', id: string, title?: string | null, image?: string | null, description?: string | null, url?: string | null }> | null, communityMember?: { __typename?: 'CommunityMemberNode', role: Types.RoleEnum, subscription: { __typename?: 'MemberSubscriptionNode', status: Types.MemberSubscriptionStatusEnum } } | null, connection?: { __typename?: 'Connection', match?: Array<string> | null, connected: boolean, connect?: { __typename?: 'ConnectionConnectNode', confirmed: Types.ConfirmedEnum, fromThey: boolean, message?: string | null, connectId: string } | null, helpReaction?: { __typename?: 'ConnectionHelpReactionNode', helpId: string, help: string } | null, workedWith?: { __typename?: 'ConnectionWorkedWithNode', confirmed: Types.ConfirmedEnum, fromThey: boolean, workedWithId: string } | null } | null } | null };

export type UsersQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.UserFilters>;
}>;


export type UsersQuery = { __typename?: 'Query', users?: { __typename?: 'UsersResultNode', objs: Array<{ __typename?: 'UserNode', id: string, firstName: string, lastName: string, image?: string | null, headline?: string | null, about?: string | null, linkFacebook?: string | null, linkInstagram?: string | null, linkTelegram?: string | null, linkLinkedin?: string | null, linkYoutube?: string | null, needHelp?: { __typename?: 'CurrentHelpNode', id: string, message: string } | null, city?: { __typename?: 'CityNode', id: string, name?: string | null } | null, tags: Array<{ __typename?: 'TagNode', id: string, name: string, isHobby: boolean }>, education?: Array<{ __typename?: 'EducationNode', id: string, speciality?: string | null, years?: string | null, fromMonth?: number | null, fromYear?: number | null, toMonth?: number | null, toYear?: number | null, university: { __typename?: 'UniversityNode', name: string, logo?: string | null } }> | null, companyExperience?: Array<{ __typename?: 'CompanyExperienceNode', id: string, description?: string | null, positionRaw?: string | null, fromMonth?: number | null, fromYear?: number | null, toMonth?: number | null, toYear?: number | null, company?: { __typename?: 'CompanyNode', id: string, name: string, logo?: string | null } | null, position?: { __typename?: 'JobTitleNode', id: string, name: string } | null }> | null, featured?: Array<{ __typename?: 'FeaturedNode', id: string, title?: string | null, image?: string | null, description?: string | null }> | null, workedWith?: Array<{ __typename?: 'WorkedWithNode', id: string, image?: string | null, name: string }> | null }> } | null };

export const CommunityDiscoveryFragmentFragmentDoc = gql`
    fragment CommunityDiscoveryFragment on CommunityNode {
  id
  subdomain
  domain
  name
  subtitle
  description
  aboutUs
  logo
  image
  tags {
    name
    id
  }
  location {
    id
    name
    partialName
    countryCode
  }
  locationGlobal
  isPublic
  joinPolicy
  hasJoined
  hasApplied
  isAdmin
  owner {
    id
    image
    firstName
    lastName
  }
  membersCount
  connectionsCount
  landing {
    headerSecondaryUrl
    headerSecondaryUrlTitle
    applicationFields {
      id
      required
      placeholder
      label
      type
      name
      orderId
    }
  }
  displayLandingApplication
}
    `;
export const WinWinChatFragmentFragmentDoc = gql`
    fragment WinWinChatFragment on WinWinChatType {
  id
  createdAt
  chat
}
    `;
export const CurrentUserFragmentFragmentDoc = gql`
    fragment CurrentUserFragment on UserNode {
  id
  firstName
  lastName
  image
  dateJoined
  linkLinkedin
  toParse
  onboardingFinished
}
    `;
export const CommunitiesDocument = gql`
    query Communities($filter: CommunitiesFilterEnum, $search: String) {
  communities(filter: $filter, search: $search) {
    objs {
      ...CommunityDiscoveryFragment
    }
  }
}
    ${CommunityDiscoveryFragmentFragmentDoc}`;
export const CommunityDocument = gql`
    query Community($subdomain: String) {
  community(subdomain: $subdomain) {
    ...CommunityDiscoveryFragment
  }
}
    ${CommunityDiscoveryFragmentFragmentDoc}`;
export const SpaceSettingsDocument = gql`
    mutation SpaceSettings($name: String!, $subtitle: String, $description: String!, $aboutUs: String, $locationId: ID, $locationGlobal: Boolean, $tags: [ID!]!) {
  spaceSettings(
    name: $name
    subtitle: $subtitle
    description: $description
    aboutUs: $aboutUs
    locationId: $locationId
    locationGlobal: $locationGlobal
    tags: $tags
  ) {
    community {
      ...CommunityDiscoveryFragment
    }
  }
}
    ${CommunityDiscoveryFragmentFragmentDoc}`;
export const CreateCommunityTagDocument = gql`
    mutation CreateCommunityTag($name: String!) {
  createCommunityTag(name: $name) {
    tag {
      id
      name
    }
  }
}
    `;
export const CommunitySettingsImageDocument = gql`
    mutation communitySettingsImage($image: String!) {
  communitySettingsImage(image: $image) {
    ok
  }
}
    `;
export const DealsDocument = gql`
    query Deals {
  dealsStats {
    uniqueUsers
    totalFee
    totalDeals
  }
  deals {
    createdAt
    id
    message
    emoji
    title
    detailsUrl
    fee
    user {
      id
      image
      firstName
      lastName
    }
    viaUsers {
      id
      image
      firstName
      lastName
    }
  }
}
    `;
export const Onb180BasicDocument = gql`
    mutation onb180Basic($firstName: String!, $lastName: String!, $cityId: ID!) {
  onb180Basic(firstName: $firstName, lastName: $lastName, cityId: $cityId) {
    success
  }
}
    `;
export const Onb180AboutDocument = gql`
    mutation onb180About($about: String!) {
  onb180About(about: $about) {
    success
  }
}
    `;
export const Onb180DreamsDocument = gql`
    mutation onb180Dreams($dreams: [DreamInput!]!) {
  onb180Dreams(dreams: $dreams) {
    success
  }
}
    `;
export const Onb180UpToDocument = gql`
    mutation onb180UpTo($upTo: String!) {
  onb180UpTo(upTo: $upTo) {
    success
  }
}
    `;
export const Onb180ProudOfDocument = gql`
    mutation onb180ProudOf($proudOf: [ProudOfInput!]!) {
  onb180ProudOf(proudOf: $proudOf) {
    success
  }
}
    `;
export const LoadCommunityTagsDocument = gql`
    mutation LoadCommunityTags($search: String) {
  loadCommunityTags(search: $search) {
    tags {
      id
      name
    }
  }
}
    `;
export const SpaceSettingsExtraDocument = gql`
    mutation SpaceSettingsExtra($subdomain: String!, $isPublic: Boolean!, $headerSecondaryUrl: String!, $headerSecondaryUrlTitle: String!) {
  spaceSettingsExtra(
    subdomain: $subdomain
    isPublic: $isPublic
    headerSecondaryUrl: $headerSecondaryUrl
    headerSecondaryUrlTitle: $headerSecondaryUrlTitle
  ) {
    community {
      id
      subdomain
      isPublic
      landing {
        headerSecondaryUrl
        headerSecondaryUrlTitle
      }
    }
  }
}
    `;
export const WinWinCreateChatDocument = gql`
    mutation WinWinCreateChat {
  winwinChatCreate {
    id
  }
}
    `;
export const WinWinUpdateChatDocument = gql`
    mutation WinWinUpdateChat($id: ID!, $chat: JSONString!) {
  winwinChatUpdate(id: $id, chat: $chat) {
    ok
  }
}
    `;
export const WinWinLoadChatDocument = gql`
    query WinWinLoadChat($id: ID) {
  winwinChat(id: $id) {
    ...WinWinChatFragment
  }
}
    ${WinWinChatFragmentFragmentDoc}`;
export const AcceptApplicationDocument = gql`
    mutation acceptApplication($id: ID!) {
  acceptApplication(applicationId: $id) {
    ok
    panelUser {
      id
      email
      firstName
      lastName
      image
    }
  }
}
    `;
export const AddNewDealDocument = gql`
    mutation AddNewDeal($message: String!, $title: String!, $fee: Int!, $detailsUrl: String) {
  dealAdd(message: $message, title: $title, fee: $fee, detailsUrl: $detailsUrl) {
    ok
  }
}
    `;
export const BlogConnectMediumDocument = gql`
    mutation blogConnectMedium($mediumJoinLink: String!) {
  blogConnectMedium(mediumJoinLink: $mediumJoinLink) {
    ok
  }
}
    `;
export const CommunitySettingsDocument = gql`
    mutation CommunitySettings($name: String!, $subdomain: String!) {
  communitySettings(name: $name, subdomain: $subdomain) {
    ok
  }
}
    `;
export const CommunitySettingsLogoDocument = gql`
    mutation communitySettingsLogo($logo: String!) {
  communitySettingsLogo(logo: $logo) {
    ok
  }
}
    `;
export const ConfirmEmailDocument = gql`
    mutation ConfirmEmail($token: String!, $uid: String!) {
  signupConfirm(token: $token, uid: $uid) {
    user {
      ...CurrentUserFragment
      communityMember {
        role
      }
      linkLinkedin
    }
    community {
      id
      domain
      subdomain
    }
  }
}
    ${CurrentUserFragmentFragmentDoc}`;
export const ConnectConfirmDocument = gql`
    mutation ConnectConfirm($connectId: ID!, $confirm: Boolean!) {
  connectConfirm(connectId: $connectId, confirm: $confirm) {
    ok
  }
}
    `;
export const ConnectTelegramDocument = gql`
    mutation connectTelegram($inviteLink: String!) {
  connectTelegram(inviteLink: $inviteLink) {
    ok
  }
}
    `;
export const ConnectWhatsappConfirmDocument = gql`
    mutation ConnectWhatsappConfirm {
  connectWhatsappConfirm {
    connected
  }
}
    `;
export const ConnectWhatsappDocument = gql`
    mutation connectWhatsapp($inviteLink: String!) {
  connectWhatsapp(inviteLink: $inviteLink) {
    ok
    manuallyRequired
  }
}
    `;
export const CreateApplicationFieldDocument = gql`
    mutation CreateApplicationField($type: LandingApplicationFieldTypeChoices!, $orderId: Int!) {
  landingCreateField(fieldType: $type, orderId: $orderId) {
    field {
      id
      required
      placeholder
      label
      name
      type
      orderId
    }
  }
}
    `;
export const CreateCommunityDocument = gql`
    mutation CreateCommunity($communityName: String!, $communitySubdomain: String, $app: CommunityAppEnum!) {
  createCommunity(
    communityName: $communityName
    communitySubdomain: $communitySubdomain
    app: $app
  ) {
    community {
      id
      subdomain
      name
    }
  }
}
    `;
export const CreateNewCompanyDocument = gql`
    mutation CreateNewCompany($name: String!, $logo: String) {
  createCompany(name: $name, logo: $logo) {
    company {
      id
      name
    }
  }
}
    `;
export const CreateNewFeaturedDocument = gql`
    mutation CreateNewFeatured($title: String!, $url: String!, $image: String, $description: String!) {
  createFeatured(
    title: $title
    url: $url
    image: $image
    description: $description
  ) {
    featured {
      id
    }
  }
}
    `;
export const CreateNewHobbyDocument = gql`
    mutation CreateNewHobby($hobby: TagInput) {
  createHobby(hobbyInput: $hobby) {
    ok
    hobby {
      id
      name
      isHobby
    }
  }
}
    `;
export const CreateQualificationDocument = gql`
    mutation CreateQualification($name: String!) {
  createQualification(name: $name) {
    qualification {
      id
      name
    }
  }
}
    `;
export const CreateNewSkillDocument = gql`
    mutation CreateNewSkill($skill: TagInput) {
  createSkill(skillInput: $skill) {
    ok
    skill {
      id
      name
      isHobby
    }
  }
}
    `;
export const CreateUniversityDocument = gql`
    mutation CreateUniversity($name: String!) {
  createUniversity(name: $name) {
    university {
      id
      name
    }
  }
}
    `;
export const DeleteDealDocument = gql`
    mutation DeleteDeal($dealId: ID!) {
  dealDelete(dealId: $dealId) {
    ok
  }
}
    `;
export const DeleteApplicationFieldDocument = gql`
    mutation DeleteApplicationField($id: ID!) {
  landingDeleteField(id: $id) {
    ok
  }
}
    `;
export const DeleteUserEducationDocument = gql`
    mutation DeleteUserEducation($id: Int!) {
  deleteEducation(id: $id) {
    success
  }
}
    `;
export const DeleteUserExperienceDocument = gql`
    mutation DeleteUserExperience($id: ID!) {
  deleteExperience(id: $id) {
    success
  }
}
    `;
export const DeleteUserFeaturedDocument = gql`
    mutation DeleteUserFeatured($id: Int!) {
  deleteFeatured(id: $id) {
    success
  }
}
    `;
export const DeleteUserProfileDocument = gql`
    mutation DeleteUserProfile {
  deleteProfile {
    ok
  }
}
    `;
export const EditDealDocument = gql`
    mutation EditDeal($dealId: ID!, $message: String!, $title: String!, $fee: Int!, $detailsUrl: String) {
  dealEdit(
    dealId: $dealId
    message: $message
    title: $title
    fee: $fee
    detailsUrl: $detailsUrl
  ) {
    ok
    deal {
      id
      message
      title
      fee
      detailsUrl
    }
  }
}
    `;
export const EditNewFeaturedDocument = gql`
    mutation EditNewFeatured($id: Int!, $title: String!, $url: String!, $image: String, $description: String!) {
  editFeatured(
    id: $id
    title: $title
    url: $url
    image: $image
    description: $description
  ) {
    featured {
      id
    }
  }
}
    `;
export const SendHelpMessageResponseDocument = gql`
    mutation SendHelpMessageResponse($message: String!, $helpMessageId: ID!) {
  helpReact(message: $message, helpMessageId: $helpMessageId) {
    id
    ok
  }
}
    `;
export const SendIntroMessageDocument = gql`
    mutation SendIntroMessage($message: String!, $toUserId: ID!) {
  connect(message: $message, toUserId: $toUserId) {
    connectLink
    ok
  }
}
    `;
export const LandingAiDocument = gql`
    mutation LandingAi($message: String!, $section: LandingSectionEnum!, $field: LandingSectionFieldEnum!) {
  landingAi(message: $message, section: $section, field: $field) {
    landing {
      appType
      applicationFields {
        id
        label
        name
        orderId
        placeholder
        required
        type
      }
      benefits {
        title
        description
        item1
        item2
        item3
        item4
        item5
        item6
      }
      cta {
        buttonText
        title
      }
      headerImage
      headerSubtitle
      headerTitle
      headerTags
      requirements {
        title
        content
      }
    }
  }
}
    `;
export const LandingAiMembersCancelDocument = gql`
    mutation LandingAiMembersCancel {
  landingAiMembersCancel {
    ok
  }
}
    `;
export const LandingAiMembersRegenerateDocument = gql`
    mutation LandingAiMembersRegenerate {
  landingAiMembersRegenerate {
    members {
      about
      id
      image
      name
      position
    }
  }
}
    `;
export const SaveLandingApplicationFieldsDocument = gql`
    mutation SaveLandingApplicationFields($fields: [ApplicationFieldInput!]!) {
  landingApplicationFields(fields: $fields) {
    fields {
      id
      required
      placeholder
      label
      name
      type
      orderId
    }
  }
}
    `;
export const LandingApplyDocument = gql`
    mutation LandingApply($values: [LandingApplyInput!]!, $communityId: ID) {
  landingApply(values: $values, communityId: $communityId) {
    ok
    inviteLink
  }
}
    `;
export const LandingBuilderVideoSeenDocument = gql`
    mutation LandingBuilderVideoSeen {
  landingBuilderVideoSeen {
    ok
  }
}
    `;
export const LandingJoinSettingsDocument = gql`
    mutation landingJoinSettings($joinPolicy: JoinPolicy!, $joinChatLink: String) {
  landingJoinSettings(joinPolicy: $joinPolicy, joinChatLink: $joinChatLink) {
    ok
  }
}
    `;
export const LandingSecondaryButtonDocument = gql`
    mutation LandingSecondaryButton($title: String!, $url: String!) {
  landingSecondaryButton(title: $title, url: $url) {
    landing {
      headerSecondaryUrl
      headerSecondaryUrlTitle
    }
  }
}
    `;
export const LoadCitiesDocument = gql`
    mutation LoadCities($search: String!) {
  loadCities(search: $search) {
    cities {
      id
      name
      fullName
      partialName
    }
  }
}
    `;
export const LoadCompaniesDocument = gql`
    mutation LoadCompanies($search: String!) {
  loadCompanies(search: $search) {
    companies {
      description
      id
      name
    }
  }
}
    `;
export const LoadHobbiesDocument = gql`
    mutation LoadHobbies($search: String!) {
  loadHobbies(search: $search) {
    hobbies {
      id
      isHobby
      name
    }
  }
}
    `;
export const LoadQualificationsDocument = gql`
    mutation LoadQualifications($search: String!) {
  loadQualifications(search: $search) {
    qualifications {
      id
      name
    }
  }
}
    `;
export const LoadSkillsDocument = gql`
    mutation LoadSkills($search: String!) {
  loadSkills(search: $search) {
    skills {
      id
      isHobby
      name
    }
  }
}
    `;
export const LoadUniversitiesDocument = gql`
    mutation LoadUniversities($search: String!) {
  loadUniversities(search: $search) {
    universities {
      id
      name
    }
  }
}
    `;
export const LoginUserDocument = gql`
    mutation LoginUser($email: String!, $password: String!) {
  login(email: $email, password: $password) {
    user {
      ...CurrentUserFragment
      communityMember {
        role
      }
      linkLinkedin
    }
    community {
      id
      domain
      subdomain
    }
  }
}
    ${CurrentUserFragmentFragmentDoc}`;
export const LogoutUserDocument = gql`
    mutation LogoutUser {
  logout {
    ok
  }
}
    `;
export const MagicSearchFeedbackDocument = gql`
    mutation MagicSearchFeedback($promptId: ID!, $liked: Boolean!) {
  magicSearchFeedback(promptId: $promptId, liked: $liked) {
    ok
  }
}
    `;
export const MemberConnectTelegramDocument = gql`
    mutation MemberConnectTelegram($hash: String!, $authDate: String!, $id: String!, $firstName: String!, $lastName: String, $username: String, $photoUrl: String) {
  memberConnectTelegram(
    hash: $hash
    authDate: $authDate
    id: $id
    firstName: $firstName
    lastName: $lastName
    username: $username
    photoUrl: $photoUrl
  ) {
    communitiesFound
    ok
  }
}
    `;
export const MemberConnectWhatsappDocument = gql`
    mutation MemberConnectWhatsapp {
  memberConnectWhatsappLink {
    link
  }
}
    `;
export const MessageDocument = gql`
    mutation Message($toUserId: ID!) {
  message(toUserId: $toUserId) {
    connectLink
    ok
  }
}
    `;
export const RejectApplicationDocument = gql`
    mutation rejectApplication($id: ID!) {
  rejectApplication(applicationId: $id) {
    ok
  }
}
    `;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($email: String!) {
  resetPassword(email: $email) {
    ok
  }
}
    `;
export const ResetPasswordConfirmDocument = gql`
    mutation ResetPasswordConfirm($password: String!, $token: String!, $uid: String!) {
  resetPasswordConfirm(password: $password, token: $token, uid: $uid) {
    ok
  }
}
    `;
export const RevokeMemberDocument = gql`
    mutation RevokeMember($communityMemberId: ID!) {
  deleteCommunityMember(communityMemberId: $communityMemberId) {
    ok
  }
}
    `;
export const SaveCanHelpDocument = gql`
    mutation SaveCanHelp($message: String!) {
  helpCan(message: $message) {
    ok
  }
}
    `;
export const SaveHobbiesDocument = gql`
    mutation SaveHobbies($hobbies: [SetTagInput]) {
  saveHobbies(hobbies: $hobbies) {
    ok
  }
}
    `;
export const SaveOnBoardingFinishedDocument = gql`
    mutation SaveOnBoardingFinished {
  saveOnboardingFinished {
    ok
  }
}
    `;
export const SaveSkillsDocument = gql`
    mutation SaveSkills($skills: [SetTagInput]) {
  saveSkills(skills: $skills) {
    ok
  }
}
    `;
export const SetCommunityDescriptionDocument = gql`
    mutation setCommunityDescription($description: String!) {
  setCommunityDescription(description: $description) {
    ok
  }
}
    `;
export const SetCommunityGoalsDocument = gql`
    mutation SetCommunityGoals($goals: [String!]!) {
  setCommunityGoals(goals: $goals) {
    ok
  }
}
    `;
export const SignupDocument = gql`
    mutation Signup($email: String!, $password: String!, $inviteHash: String) {
  signup(email: $email, password: $password, inviteHash: $inviteHash) {
    user {
      id
    }
  }
}
    `;
export const StartDocument = gql`
    mutation Start($inviteLink: String!) {
  start(inviteLink: $inviteLink) {
    community {
      id
      subdomain
      name
    }
  }
}
    `;
export const TelegramAuthUserDocument = gql`
    mutation TelegramAuthUser($initData: String!) {
  telegramAuth(initData: $initData) {
    user {
      ...CurrentUserFragment
    }
  }
}
    ${CurrentUserFragmentFragmentDoc}`;
export const UpdateEducationDocument = gql`
    mutation UpdateEducation($qualificationId: ID!, $universityId: ID!, $description: String!, $fromMonth: Int, $fromYear: Int!, $toMonth: Int, $toYear: Int, $id: ID) {
  updateEducation(
    qualificationId: $qualificationId
    universityId: $universityId
    description: $description
    fromMonth: $fromMonth
    fromYear: $fromYear
    toMonth: $toMonth
    toYear: $toYear
    id: $id
  ) {
    education {
      university {
        id
        name
      }
      fromMonth
      fromYear
      toMonth
      toYear
      description
      id
      qualification {
        id
        name
      }
    }
  }
}
    `;
export const UpdateExperienceDocument = gql`
    mutation UpdateExperience($companyId: ID!, $description: String!, $fromMonth: Int, $fromYear: Int!, $position: String!, $toMonth: Int, $toYear: Int, $id: ID) {
  updateExperience(
    companyId: $companyId
    description: $description
    position: $position
    fromMonth: $fromMonth
    fromYear: $fromYear
    toMonth: $toMonth
    toYear: $toYear
    id: $id
  ) {
    experience {
      company {
        description
        id
        name
      }
      positionRaw
      fromMonth
      fromYear
      toMonth
      toYear
      description
      id
      position {
        id
        name
      }
    }
  }
}
    `;
export const UpdateBaseProfileDocument = gql`
    mutation UpdateBaseProfile($firstName: String, $lastName: String, $about: String, $linkYoutube: String, $linkTelegram: String, $linkLinkedin: String, $linkInstagram: String, $linkFacebook: String, $linkTwitter: String, $linkGithub: String, $linkCalendly: String, $linkTiktok: String, $cityId: ID, $dreams: [DreamInput!]!, $services: [ServiceInput!]!, $proudOf: [ProudOfInput!]!, $upTo: String, $videoUrl: String) {
  updateBaseProfile(
    firstName: $firstName
    lastName: $lastName
    about: $about
    dreams: $dreams
    services: $services
    proudOf: $proudOf
    upTo: $upTo
    videoUrl: $videoUrl
    linkYoutube: $linkYoutube
    linkTelegram: $linkTelegram
    linkLinkedin: $linkLinkedin
    linkInstagram: $linkInstagram
    linkFacebook: $linkFacebook
    linkTwitter: $linkTwitter
    linkGithub: $linkGithub
    linkCalendly: $linkCalendly
    linkTiktok: $linkTiktok
    cityId: $cityId
  ) {
    user {
      id
      firstName
      lastName
      about
      headline
      city {
        partialName
        name
        id
      }
      linkLinkedin
      linkInstagram
      linkTwitter
      linkGithub
      linkCalendly
      linkTiktok
      dreams {
        title
        achieved
      }
      services {
        title
        price
      }
      upTo
      proudOf {
        title
        imageUrl
        description
        url
      }
      videoUrl
    }
  }
}
    `;
export const WorkedWithDocument = gql`
    mutation WorkedWith($userId: ID!) {
  workedWith(userId: $userId) {
    ok
  }
}
    `;
export const WorkedWithConfirmDocument = gql`
    mutation WorkedWithConfirm($workedWithId: ID!, $confirm: Boolean!) {
  workedWithConfirm(workedWithId: $workedWithId, confirm: $confirm) {
    ok
  }
}
    `;
export const LandingPublishDocument = gql`
    mutation LandingPublish {
  landingPublish {
    ok
  }
}
    `;
export const LandingSetBenefitsFieldsDocument = gql`
    mutation LandingSetBenefitsFields($benefitsInput: LandingBenefitsInput!) {
  landingSetFields(benefits: $benefitsInput) {
    landing {
      benefits {
        title
        description
        item1
        item2
        item3
        item4
        item5
        item6
      }
    }
  }
}
    `;
export const LandingSetCtaFieldsDocument = gql`
    mutation LandingSetCTAFields($title: String!, $buttonText: String!) {
  landingSetFields(cta: {title: $title, buttonText: $buttonText}) {
    landing {
      cta {
        title
        buttonText
      }
    }
  }
}
    `;
export const LandingSetHeaderFieldsDocument = gql`
    mutation LandingSetHeaderFields($headerFields: LandingHeaderInput!) {
  landingSetFields(header: $headerFields) {
    landing {
      headerSubtitle
      headerTags
      headerTitle
      membersNumber
      youtubeVideoUrl
    }
  }
}
    `;
export const LandingSetHeaderImageDocument = gql`
    mutation LandingSetHeaderImage($image: String!) {
  landingSetHeaderImage(image: $image) {
    landing {
      headerImage
    }
  }
}
    `;
export const LandingSetMemberFieldsDocument = gql`
    mutation LandingSetMemberFields($member: LandingMemberInput!) {
  landingMember(member: $member) {
    member {
      id
      name
      position
      about
      image
    }
  }
}
    `;
export const LandingSetMemberImageDocument = gql`
    mutation LandingSetMemberImage($image: String!, $memberId: ID!) {
  landingMemberImage(image: $image, memberId: $memberId) {
    member {
      image
    }
  }
}
    `;
export const LandingSetRequirementsFieldsDocument = gql`
    mutation LandingSetRequirementsFields($title: String!, $content: String!) {
  landingSetFields(requirements: {title: $title, content: $content}) {
    landing {
      requirements {
        title
        content
      }
    }
  }
}
    `;
export const SaveImageProfileDocument = gql`
    mutation saveImageProfile($image: String!) {
  saveImageProfile(image: $image) {
    image
  }
}
    `;
export const SaveLinkedInDocument = gql`
    mutation saveLinkedIn($linkLinkedin: String!) {
  saveLinkedin(linkLinkedin: $linkLinkedin) {
    ok
  }
}
    `;
export const SaveSocialDocument = gql`
    mutation SaveSocial($linkFacebook: String, $linkInstagram: String, $linkLinkedin: String, $linkTelegram: String, $linkYoutube: String) {
  saveSocial(
    linkFacebook: $linkFacebook
    linkInstagram: $linkInstagram
    linkLinkedin: $linkLinkedin
    linkTelegram: $linkTelegram
    linkYoutube: $linkYoutube
  ) {
    user {
      id
      firstName
      lastName
      about
    }
  }
}
    `;
export const SetPricingDocument = gql`
    mutation setPricing($monthly: Decimal!) {
  setPricing(monthly: $monthly) {
    pricing {
      monthly
    }
  }
}
    `;
export const SetSubscriptionTypeDocument = gql`
    mutation setSubscriptionType($type: SubscriptionTypeEnum!) {
  setSubscriptionType(type: $type) {
    next
    ok
  }
}
    `;
export const ActivityDocument = gql`
    query activity {
  activity {
    ... on HelpReactionNode {
      __typename
      user {
        id
        image
        firstName
        lastName
      }
      createdAt
    }
    ... on WorkedWithRequestNode {
      __typename
      workedWithId: id
      workedWithCreatedAt: createdAt
      fromUser {
        id
        image
        firstName
        lastName
      }
      workedWithConfirmed: confirmed
    }
    ... on ConnectNode {
      __typename
      connectId: id
      connectCreatedAt: createdAt
      message
      connectFromUser: fromUser {
        id
        image
        firstName
        lastName
      }
      connectConfirmed: confirmed
    }
    ... on HelpNode {
      helpCreatedAt: createdAt
      helpNodeId: id
      helpMessage: message
      helpFromUser: user {
        id
        image
        firstName
        lastName
      }
    }
    ... on JoinedMemberNode {
      __typename
      joinedAt
      joinedMemberUser: user {
        id
        firstName
        lastName
        image
      }
    }
  }
}
    `;
export const ActivityCountDocument = gql`
    query ActivityCount {
  activityCount
}
    `;
export const AllCitiesDocument = gql`
    query AllCities($search: String!) {
  allCities(search: $search) {
    id
    name
  }
}
    `;
export const AnalyticsActivationDocument = gql`
    query AnalyticsActivation {
  analyticsActivationPeriod {
    periodLast
    periodAll
  }
}
    `;
export const AnalyticsApplicationsDocument = gql`
    query AnalyticsApplications($filters: FiltersV2!) {
  analyticsApplications(filters: $filters) {
    timestamp
    new
    accepted
    rejected
  }
}
    `;
export const AnalyticsHeatmapMessagesDocument = gql`
    query AnalyticsHeatmapMessages {
  analyticsHeatmap {
    timestamp
    messages
  }
}
    `;
export const AnalyticsMembersCountriesDocument = gql`
    query AnalyticsMembersCountries {
  analyticsMembersCountries {
    countryCode
    members
  }
}
    `;
export const AnalyticsMembersLeftListDocument = gql`
    query AnalyticsMembersLeftList($filters: FiltersV2!) {
  analyticsMembersLeft(filters: $filters) {
    leftAt
    name
    rawId
    image
    user {
      id
      lastName
      firstName
      image
      city {
        name
      }
    }
  }
}
    `;
export const AnalyticsMembersLeftV2Document = gql`
    query AnalyticsMembersLeftV2($limit: Int, $offset: Int, $filters: FiltersV2) {
  analyticsMembersLeftV2(limit: $limit, offset: $offset, filters: $filters) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        rawId
        leftAt
        image
        name
        user {
          id
          image
          firstName
          lastName
          city {
            name
          }
        }
      }
    }
    totalCount
  }
}
    `;
export const AnalyticsMembersLifetimeListDocument = gql`
    query AnalyticsMembersLifetimeList {
  analyticsMembersLifetime {
    group
    members
  }
}
    `;
export const AnalyticsMembersTopListDocument = gql`
    query AnalyticsMembersTopList($filters: FiltersV2!) {
  analyticsMembersTop(filters: $filters) {
    messages
    name
    rawId
    image
    link {
      url
      service
    }
    user {
      id
      lastName
      firstName
      image
      city {
        name
      }
    }
  }
}
    `;
export const AnalyticsMessageTypesListDocument = gql`
    query AnalyticsMessageTypesList($filters: FiltersV2!) {
  analyticsMessageTypes(filters: $filters) {
    messageType
    messages
  }
}
    `;
export const AnalyticsStagesDocument = gql`
    query AnalyticsStages {
  analyticsStages {
    members
    stage
  }
}
    `;
export const AnalyticsApplicationsSummaryDocument = gql`
    query AnalyticsApplicationsSummary($filters: FiltersV2!) {
  analyticsSummaryApplications(filters: $filters) {
    applications
    applicationsChange
  }
}
    `;
export const AnalyticsLikesSummaryDocument = gql`
    query AnalyticsLikesSummary($filters: FiltersV2!) {
  analyticsSummaryLikes(filters: $filters) {
    likes
    likesChange
  }
}
    `;
export const AnalyticsMembersSummaryDocument = gql`
    query AnalyticsMembersSummary($filters: FiltersV2!) {
  analyticsSummaryMembers(filters: $filters) {
    members
    membersChange
  }
}
    `;
export const AnalyticsMessagesSummaryDocument = gql`
    query AnalyticsMessagesSummary($filters: FiltersV2!) {
  analyticsSummaryMessages(filters: $filters) {
    messages
    messagesChange
  }
}
    `;
export const AnalyticsV2MembersDocument = gql`
    query AnalyticsV2Members($filters: FiltersV2!) {
  analyticsMembers(filters: $filters) {
    timestamp
    joined
    left
  }
}
    `;
export const AnalyticsV2MessagesDocument = gql`
    query AnalyticsV2Messages($filters: FiltersV2!) {
  analyticsMessages(filters: $filters) {
    timestamp
    users
    messages
    avgMessages
  }
}
    `;
export const AnalyticsV2ReactionsDocument = gql`
    query AnalyticsV2Reactions($filters: FiltersV2!) {
  analyticsReactions(filters: $filters) {
    timestamp
    reactions
  }
}
    `;
export const AnalyticsV2StatsDocument = gql`
    query AnalyticsV2Stats($filters: FiltersV2!) {
  analyticsStats(filters: $filters) {
    timestamp
    chatMembers
    profiles
    landingViews
    landingClicks
    referrers {
      referrer
      count
    }
    stagesNotActivated
    stagesActivated
    stagesEngaged
    stagesLost
    stagesActivatedPeriod
    stagesEngagedPeriod
    stagesLostPeriod
  }
}
    `;
export const LandingApplicationFieldsDocument = gql`
    query LandingApplicationFields {
  landing {
    applicationFields {
      id
      required
      placeholder
      label
      type
      name
      orderId
    }
  }
}
    `;
export const BlogRecentDocument = gql`
    query BlogRecent {
  blogRecent {
    content
    createdAt
    fullUrl
    image
    title
  }
  blogUrl
}
    `;
export const CitiesDocument = gql`
    query Cities {
  cities {
    id
    name
  }
}
    `;
export const ApplicationDocument = gql`
    query Application($id: ID!) {
  application(id: $id) {
    id
    createdAt
    name
    phone
    email
    status
    answers {
      label
      value
    }
  }
}
    `;
export const ApplicationsDocument = gql`
    query Applications($status: [CommunityApplicationStatusChoices!]!) {
  applications(status: $status) {
    applications {
      id
      createdAt
      name
      phone
      email
      status
      answers {
        label
        value
      }
    }
  }
}
    `;
export const ApplicationsCountDocument = gql`
    query ApplicationsCount($status: [CommunityApplicationStatusChoices!]!) {
  applications(status: $status) {
    count
  }
}
    `;
export const CommunityInfoDocument = gql`
    query CommunityInfo {
  communityInfo {
    id
    name
    subtitle
    description
    logo
    videoEmbeddedLink
    subdomain
    domain
    membersCount
    isTelegramConnected
    isWhatsappConnected
    historyDownloadStarted
    historyDownloadFinished
    historyDownloadError
    app
    joinPolicy
    membersConfirmation
    displayLandingApplication
    telegramJoinChatLink
    isWhatsappGroupJoined
    isWhatsappGroupSet
    mediumJoinLink
    pricing {
      monthly
    }
    subscriptionConnectionLink
    subscriptionType
    stripePayoutsEnabled
    stripeChargesEnabled
    stripeDetailsSubmitted
  }
}
    `;
export const CompanyNodesDocument = gql`
    query CompanyNodes($name: String, $first: Int) {
  companies(name: $name, first: $first) {
    id
    name
  }
}
    `;
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    ...CurrentUserFragment
    tags {
      id
      isHobby
      name
      usersCount
    }
    communityMember {
      role
      subscription {
        status
      }
    }
    communityMembers {
      role
      subscription {
        status
      }
      community {
        id
        subdomain
        name
        logo
        membersCount
      }
    }
    profileStatus
    inviteHash
    workedWith {
      id
      image
      name
    }
    isTelegramConnected
    isWhatsappConnected
    isLinkedinError
  }
}
    ${CurrentUserFragmentFragmentDoc}`;
export const EducationDocument = gql`
    query Education($ID: Int!) {
  education(id: $ID) {
    id
    university {
      id
      name
    }
    qualification {
      id
      name
    }
    description
  }
}
    `;
export const ExperienceDocument = gql`
    query Experience($ID: ID!) {
  experience(id: $ID) {
    id
    company {
      id
      name
    }
    position {
      id
      name
    }
    description
  }
}
    `;
export const FeaturedDocument = gql`
    query Featured($ID: Int!) {
  featured(id: $ID) {
    id
    title
    description
    image
    url
  }
}
    `;
export const FiltersValuesDocument = gql`
    query FiltersValues {
  cities {
    id
    name
  }
  directions {
    id
    name
    usersCount
  }
  jobTitles {
    id
    name
    usersCount
  }
  tags {
    id
    isHobby
    name
    usersCount
  }
}
    `;
export const HobbiesDocument = gql`
    query Hobbies($systemOnly: Boolean) {
  hobbies(systemOnly: $systemOnly) {
    isHobby
    id
    name
  }
}
    `;
export const InviteUserDocument = gql`
    query InviteUser($inviteHash: String, $redirect: String) {
  invitedByUser(inviteHash: $inviteHash) {
    ...CurrentUserFragment
  }
  oauthLinks(inviteHash: $inviteHash, redirect: $redirect) {
    provider
    link
  }
}
    ${CurrentUserFragmentFragmentDoc}`;
export const IsLoggedInDocument = gql`
    query IsLoggedIn {
  isLoggedIn
}
    `;
export const JobTitleNodesDocument = gql`
    query JobTitleNodes($name: String) {
  positions(name: $name) {
    id
    name
  }
}
    `;
export const JobTypesDocument = gql`
    query JobTypes {
  jobTypeChoices {
    value
    label
  }
}
    `;
export const LandingDocument = gql`
    query Landing {
  landing {
    id
    headerImage
    headerSubtitle
    headerTags
    headerTitle
    headerButtonCustom
    icons
    youtubeVideoUrl
    members {
      about
      id
      image
      name
      position
    }
    benefits {
      title
      description
      item1
      item2
      item3
      item4
      item5
      item6
    }
    cta {
      buttonText
      title
    }
    membersNumber
    requirements {
      title
      content
    }
    builderVideoSeen
    headerSecondaryUrl
    headerSecondaryUrlTitle
    membersStatus
  }
}
    `;
export const LandingMembersDocument = gql`
    query LandingMembers {
  landing {
    members {
      about
      id
      image
      name
      position
    }
    membersNumber
    membersStatus
  }
}
    `;
export const LoginWhatsappDocument = gql`
    mutation loginWhatsapp($codeId: String!) {
  memberConnectWhatsappConfirm(codeId: $codeId) {
    user {
      ...CurrentUserFragment
    }
  }
}
    ${CurrentUserFragmentFragmentDoc}`;
export const MembersDocument = gql`
    query Members($filters: UserFilters, $promptId: ID, $lastId: ID) {
  users(filters: $filters, promptId: $promptId, lastId: $lastId) {
    objs {
      id
      firstName
      lastName
      image
      headline
      communityMembers {
        community {
          id
          name
          subdomain
          domain
          logo
        }
      }
      needHelp {
        id
        message
      }
      city {
        name
      }
      workedWith {
        id
        image
        name
      }
      connection {
        connect {
          confirmed
          fromThey
          message
          connectId
        }
        helpReaction {
          helpId
          help
        }
        workedWith {
          confirmed
          fromThey
          workedWithId
        }
        match
        connected
      }
    }
    promptId
    hasMore
  }
}
    `;
export const PanelV2Document = gql`
    query PanelV2 {
  panel {
    ... on ApplicationNode {
      __typename
      id
      createdAt
      name
      phone
      email
      status
      member {
        userId
      }
    }
    ... on PanelMemberNode {
      __typename
      id
      createdAt
      applicationId
      role
      revokedAt
      user {
        id
        email
        firstName
        lastName
        image
      }
    }
    ... on RejectedApplicationNode {
      __typename
      id
      createdAt
      name
      phone
      email
      status
      statusChangedAt
      member {
        userId
      }
    }
    ... on PanelRevokedNode {
      __typename
      id
      createdAt
      applicationId
      role
      revokedAt
      user {
        id
        email
        firstName
        lastName
        image
      }
    }
  }
}
    `;
export const QualificationNodesDocument = gql`
    query QualificationNodes($name: String) {
  qualifications(name: $name) {
    id
    name
  }
}
    `;
export const RequestsDocument = gql`
    query Requests {
  requests {
    request
  }
}
    `;
export const SkillsDocument = gql`
    query Skills($systemOnly: Boolean) {
  skills(systemOnly: $systemOnly) {
    isHobby
    id
    name
  }
}
    `;
export const StatMembersListDocument = gql`
    query StatMembersList {
  statMembers {
    id
    idRaw
    username
    bio
    name
    languageCode
    phone
    picture
    joinedAt
    leftAt
    messagesSent
    reactionsSent
    stage
    aiCity
    aiSummary
    aiAchievements
    aiTags
    aiCurrentJob
    aiCurrentCompany
    aiLookingFor
    aiCurrentJob
    aiCurrentCompany
    aiLinkedin
    aiProjectUrl
    aiSearchPrompts
    aiLookupLinkedinUrl
    aiLookupLinkedinFirstName
    aiLookupLinkedinLastName
    aiLookupLinkedinBioSummary
    aiLookupLinkedinNotFound
    aiLookupLinkedinProbability
    aiLookupLinkedinUpdatedAt
  }
}
    `;
export const StatMessagesListDocument = gql`
    query StatMessagesList {
  statMessages {
    rawMessage
    reactions {
      count
      reaction
    }
    reactionsCount
    timestamp
  }
}
    `;
export const StripeCustomerPortalUrlDocument = gql`
    query StripeCustomerPortalUrl($returnUrl: String!) {
  stripeCustomerPortalUrl(returnUrl: $returnUrl)
}
    `;
export const StripeEmbeddedCodeDocument = gql`
    query StripeEmbeddedCode {
  stripeEmbedded
}
    `;
export const SubscriptionDocument = gql`
    query Subscription {
  currentUser {
    communityMember {
      role
      subscription {
        status
        stripeSubscription {
          createdAt
          description
          price
          status
          invoices {
            total
            status
            currency
            datetime
          }
          currentPeriodEnd
          currentPeriodStart
        }
      }
    }
  }
}
    `;
export const TelegramConfigurationDocument = gql`
    query TelegramConfiguration {
  telegramConfiguration {
    botHandle
    authUrl
  }
}
    `;
export const UniversityNodesDocument = gql`
    query UniversityNodes($name: String) {
  universities(name: $name) {
    id
    name
  }
}
    `;
export const UserDocument = gql`
    query User($ID: ID) {
  user(id: $ID) {
    id
    firstName
    lastName
    image
    headline
    about
    seoNoindex
    needHelp {
      id
      message
      currentUserReacted
      reactedBy
      reactedByV2 {
        image
        userId
        name
      }
    }
    city {
      id
      name
      partialName
    }
    tags {
      id
      name
      isHobby
    }
    dreams {
      title
      achieved
    }
    services {
      title
      price
    }
    proudOf {
      title
      imageUrl
      description
      url
    }
    videoUrl
    videoEmbedUrl
    upTo
    education {
      id
      university {
        id
        name
        logo
      }
      qualification {
        id
        name
      }
      speciality
      years
      fromMonth
      fromYear
      toMonth
      toYear
    }
    companyExperience {
      id
      company {
        id
        name
        logo
      }
      position {
        id
        name
      }
      description
      positionRaw
      fromMonth
      fromYear
      toMonth
      toYear
    }
    featured {
      id
      title
      image
      description
      url
    }
    linkFacebook
    linkInstagram
    linkTelegram
    linkLinkedin
    linkYoutube
    linkGithub
    linkTwitter
    linkCalendly
    linkTiktok
    toParse
    communityMember {
      role
      subscription {
        status
      }
    }
    onboardingFinished
    profileStatus
    connection {
      connect {
        confirmed
        fromThey
        message
        connectId
      }
      helpReaction {
        helpId
        help
      }
      workedWith {
        confirmed
        fromThey
        workedWithId
      }
      match
      connected
    }
  }
}
    `;
export const UsersDocument = gql`
    query Users($filters: UserFilters) {
  users(filters: $filters) {
    objs {
      id
      firstName
      lastName
      image
      headline
      about
      needHelp {
        id
        message
      }
      city {
        id
        name
      }
      tags {
        id
        name
        isHobby
      }
      education {
        id
        university {
          name
          logo
        }
        speciality
        years
        fromMonth
        fromYear
        toMonth
        toYear
      }
      companyExperience {
        id
        company {
          id
          name
          logo
        }
        position {
          id
          name
        }
        description
        positionRaw
        fromMonth
        fromYear
        toMonth
        toYear
      }
      featured {
        id
        title
        image
        description
      }
      linkFacebook
      linkInstagram
      linkTelegram
      linkLinkedin
      linkYoutube
      workedWith {
        id
        image
        name
      }
    }
  }
}
    `;